import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase/firebase";
import { 
  doc, getDoc, collection, addDoc, updateDoc, 
  query, where, getDocs, orderBy, deleteDoc
} from "firebase/firestore";

import "../App.css";
import { useRef } from "react";
import { onSnapshot } from "firebase/firestore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarioNutricionista from "../components/CalendarioNutricionista";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FaInstagram } from "react-icons/fa";



 
function Dashboard(){ 

  // 🔹 ESTADOS
  
  const [userData, setUserData] = useState(null);
  const [legajos, setLegajos] = useState([]);
  const [turnos, setTurnos] = useState([]);
  const [pacientes, setPacientes] = useState({});
  const [legajoPaciente, setLegajoPaciente] = useState([]);
  const [nuevoPeso, setNuevoPeso] = useState("");
  const [fechaTurno, setFechaTurno] = useState("");
  const [tab, setTab] = useState("turnos");
  const [dietaPaciente, setDietaPaciente] = useState([]);
  const [nuevaDietaUrl, setNuevaDietaUrl] = useState("");
  const [nuevoNombreDieta, setNuevoNombreDieta] = useState("");
  const [observaciones, setObservaciones] = useState([]);
  const [nuevaObservacion, setNuevaObservacion] = useState("");
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState(null);
  const [mostrarObservaciones, setMostrarObservaciones] = useState(false);
  const [observacionEditando, setObservacionEditando] = useState(null);
  // 🔹 estado para el ancho de pantalla
const [screenWidth, setScreenWidth] = useState(window.innerWidth);
const [mostrarMenu, setMostrarMenu] = useState(false);
const [mostrarBoton, setMostrarBoton] = useState(true);
const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
const [mostrarCalendario, setMostrarCalendario] = useState(false);
const [diasBloqueados, setDiasBloqueados] = useState([]);
const [horariosBloqueados, setHorariosBloqueados] = useState({});
const [filtro, setFiltro] = useState("futuros");
const [dietas, setDietas] = useState([]);
const [verTodosTurnos, setVerTodosTurnos] = useState(false);
const [mostrarHistorial, setMostrarHistorial] = useState(false);
const [noticias, setNoticias] = useState([]);
const [editandoEmail, setEditandoEmail] = useState(null);
const [nuevoEmail, setNuevoEmail] = useState("");
const [editandoTelefono, setEditandoTelefono] = useState(null);
const [nuevoTelefono, setNuevoTelefono] = useState("");
const [guardandoDieta, setGuardandoDieta] = useState(false);
const [dietaOk, setDietaOk] = useState(false);
const [mostrarFormularioDieta, setMostrarFormularioDieta] = useState(false);
const [nutritips, setNutritips] = useState([]);
const [mostrarFormularioTip, setMostrarFormularioTip] = useState(false);
const [nuevoTipTitulo, setNuevoTipTitulo] = useState("");
const [nuevoTipTexto, setNuevoTipTexto] = useState("");
const [editandoTip, setEditandoTip] = useState(null);
const [guia, setGuia] = useState(null);
const [guiaUrl, setGuiaUrl] = useState("");
const [guias, setGuias] = useState([]);
const [guiaTitulo, setGuiaTitulo] = useState("");

const [pesoMedicion, setPesoMedicion] = useState("");
const [observacionesMedicion, setObservacionesMedicion] = useState("");
const [filtroAnio, setFiltroAnio] =
useState(new Date().getFullYear());

const [filtroMes, setFiltroMes] =
useState(new Date().getMonth() + 1);


const [alturaMedicion, setAlturaMedicion] = useState("");
const [cinturaMedicion, setCinturaMedicion] = useState("");
const [caderaMedicion, setCaderaMedicion] = useState("");
const [generoMedicion, setGeneroMedicion] = useState("");
const [historialMediciones, setHistorialMediciones] = useState([]);
const [cuelloMedicion, setCuelloMedicion] = useState("");
const [pechoMedicion, setPechoMedicion] = useState("");
const [brazoMedicion, setBrazoMedicion] = useState("");
const [mostrarFormularioMedicion,
  setMostrarFormularioMedicion] = useState(false);
  const [busquedaPaciente,
    setBusquedaPaciente] = useState("");
    const [busquedaTurno,
      setBusquedaTurno] = useState("");

      









const contentRef = useRef(null);

const ahora = new Date();





const normalizarFecha = (f) => {
  if (!f) return null;
  return f.toDate ? f.toDate() : new Date(f);
};
const puedeActualizarPeso = (ultimaFecha) => {
  const fecha = normalizarFecha(ultimaFecha);
  if (!fecha) return true;

  const diffDias =
    (new Date() - fecha) / (1000 * 60 * 60 * 24);

  return diffDias >= 14;
};

const diasRestantes = (ultimaFecha) => {
  const fecha = normalizarFecha(ultimaFecha);
  if (!fecha) return 0;

  const diffDias = Math.floor(
    (new Date() - fecha) / (1000 * 60 * 60 * 24)
  );

  return Math.max(14 - diffDias, 0);
};

const legajosOrdenados = [...legajos].sort((a, b) => {
  const fa = a.fecha?.toDate ? a.fecha.toDate() : new Date(a.fecha);
  const fb = b.fecha?.toDate ? b.fecha.toDate() : new Date(b.fecha);
  return fa - fb; // viejo → nuevo
});

const obtenerFecha = (f) => {
  if (!f) return null;
  return f.toDate ? f.toDate() : new Date(f);
};

const ultimoRegistro = legajosOrdenados[legajosOrdenados.length - 1];

const fechaBase =
  obtenerFecha(ultimoRegistro?.fecha) ||
  obtenerFecha(userData?.createdAt);

const card = {
    background: "white",
    borderRadius: "12px",
    padding: "15px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    border: "1px solid #e2e8f0"
  };

  const functions = getFunctions();
const cambiarEmailPaciente = httpsCallable(
  functions,
  "cambiarEmailPaciente"
);

const guardarEmail = async () => {
  try {
    const res = await cambiarEmailPaciente({
      uid: pacienteSeleccionado,
      nuevoEmail: nuevoEmail.trim()
    });

    alert(res.data.message);

    // 🔥 ESTO TE FALTA
    setPacientes((prev) => ({
      ...prev,
      [pacienteSeleccionado]: {
        ...prev[pacienteSeleccionado],
        email: nuevoEmail.trim()
      }
    }));

    setEditandoEmail(null);
    setNuevoEmail("");

  } catch (error) {
    alert(error.message);
  }
};

const guardarTelefono = async (id) => {
  const limpio = nuevoTelefono.replace(/\D/g, "");

  if (limpio.length !== 10) {
    alert("Teléfono inválido");
    return;
  }

  await updateDoc(doc(db, "users", id), {
    telefono: limpio
  });
  
  // 🔥 actualizar UI sin recargar
  setPacientes(prev => ({
    ...prev,
    [id]: {
      ...prev[id],
      telefono: limpio
    }
  }));
  
  setEditandoTelefono(null);
  setNuevoTelefono("");
};

  const isDark = false //window.matchMedia("(prefers-color-scheme: dark)").matches;

  const colors = {
    bg: isDark ? "#0f172a" : "#f8fafc",
    card: isDark ? "#1e293b" : "#ffffff",
    cardSoft: isDark ? "#020617" : "#f1f5f9",
    border: isDark ? "#334155" : "#e2e8f0",
    text: isDark ? "#e2e8f0" : "#0f172a",
    primary: isDark ? "#16a34a" : "#15803d"
  };

  const btn = {
    padding: "8px 12px",
    borderRadius: "6px",
    border: "none",
    background: colors.primary,
    color: "white",
    cursor: "pointer",
    transition: "0.2s"
  };

  const btn2 = {
    padding: "8px 12px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    transition: "0.2s"
  };


  const input = {
    padding: "8px 12px",
    borderRadius: "6px",
    border: `1px solid ${colors.border}`,
    marginTop: "5px",
    width: "100%",
    boxSizing: "border-box", // 👈 CLAVE
    minWidth: 0,              // 👈 importante en flex layouts
    overflow: "hidden",       // 👈 evita desbordes raros
    textOverflow: "ellipsis", // 👈 si es muy largo
    background: colors.card,
    color: colors.text
  };

  const inputWrapper = {
    position: "relative",
    width: "100%",
  };
  
  const inputWithUnit = {
    ...input,
    paddingRight: "55px",
  };
  
  const unitLabel = {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: 600,
    pointerEvents: "none",
  };

const navigate = useNavigate();

useEffect(() => {
  const checkUser = async () => {
    const user = auth.currentUser;

    if (!user) {
      navigate("/");
      return;
    }

    await user.reload(); // 🔥 importante

    if (!user.emailVerified) {
      navigate("/verificar-email");
    }
  };

  checkUser();
}, [navigate]);

const handleLogout = async () => {
  await signOut(auth);
  navigate("/");
}


  // 🔹 useEffect (carga inicial)
  useEffect(() => {

    const init = async () => {
  
      await fetchUser();
  
      await fetchLegajos();
  
      await fetchPacientes();
  
    };
  
    init();
  
  }, []);
  
  useEffect(() => {
    if (userData?.role !== "paciente") return;
  
    const user = auth.currentUser;
    if (!user) return;
  
    const q = query(
      collection(db, "dietas"),
      where("patientId", "==", user.uid)
    );
  
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const datos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
  
      setDietas(datos);
    });
  
    return () => unsubscribe();
  }, [userData]);

  const [, forceUpdate] =
  useState(0);

useEffect(() => {
  const interval =
    setInterval(() => {
      forceUpdate(
        prev => prev + 1
      );
    }, 1000 * 60 * 60); // 1 hora

  return () =>
    clearInterval(interval);
}, []);



  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "noticias"),
      (snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
  
        // ordenar por fecha DESC
        data.sort((a, b) => b.fecha?.seconds - a.fecha?.seconds);
  
        setNoticias(data);
      }
    );
  
    return () => unsub();
  }, []);



  useEffect(() => {
    const q = query(collection(db, "nutritips"));
  
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
  
      setNutritips(data);
    });
  
    return () => unsubscribe();
  }, []);



  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "guiaMedicion"),
      (snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
  
        setGuias(data);
      }
    );
  
    return () => unsubscribe(); // 🔥 limpia listener
  }, []);
  


  useEffect(() => {
    const el = contentRef.current;
    console.log("REF:", el); // 👈 AGREGÁ ESTO
  
    if (!el) return;
  
    let lastScroll = 0;
  
    const handleScroll = () => {
      const currentScroll = el.scrollTop;
  
      console.log("SCROLL:", currentScroll); // 👈 Y ESTE
  
      if (currentScroll > lastScroll && currentScroll > 50) {
        setMostrarBoton(false);
      } else {
        setMostrarBoton(true);
      }
  
      lastScroll = currentScroll;
    };
  
    el.addEventListener("scroll", handleScroll);
  
    return () => el.removeEventListener("scroll", handleScroll);
  }, [userData]);


  useEffect(() => {
    const unsubDias = onSnapshot(collection(db, "bloqueosDias"), (snapshot) => {
      const dias = snapshot.docs.map(doc => doc.id);
      setDiasBloqueados(dias);
    });
  
    const unsubHorarios = onSnapshot(collection(db, "bloqueosHorarios"), (snapshot) => {
      const data = {};
  
      snapshot.docs.forEach(doc => {
        const { fecha, hora } = doc.data();
  
        if (!data[fecha]) data[fecha] = [];
        data[fecha].push(hora);
      });
  
      setHorariosBloqueados(data);
    });
  
    return () => {
      unsubDias();
      unsubHorarios();
    };
  }, []);


  useEffect(() => {
    if (tab === "pacientes") {
      fetchPacientes();
    }
  }, [tab]);



  // 🔹 TRAER USUARIO
  const fetchUser = async () => {
    const user = auth.currentUser;
    if (user) {
      const docSnap = await getDoc(doc(db, "users", user.uid));
      if (docSnap.exists()) setUserData(docSnap.data());
    }
  };

  // 🔹 TRAER LEGAJOS (PACIENTE)
  const fetchLegajos = async () => {
    const user = auth.currentUser;
    if (user) {
      const q = query(
        collection(db, "legajos"),
        where("userId", "==", user.uid),
        orderBy("fecha", "desc")
      );
      const snapshot = await getDocs(q);
      setLegajos(snapshot.docs.map(doc => doc.data()));
    }
  };


    // 🔹 CALCULAR EDAD

    const calcularEdad = (fechaNacimiento) => {
      const [dia, mes, anio] = fechaNacimiento.split("/").map(Number);
    
      const hoy = new Date();
    
      let edad = hoy.getFullYear() - anio;
    
      const m = hoy.getMonth() - (mes - 1);
    
      if (m < 0 || (m === 0 && hoy.getDate() < dia)) {
        edad--;
      }
    
      return edad;
    };



  

  // 🔹 CREAR TURNO (PACIENTE)
  const crearTurno = async () => {
    try {
      const user = auth.currentUser;

      if (!turnoSeleccionado) {
        alert("Selecciona un horario");
        return;
      }
  
      if (!turnoSeleccionado) {
        alert("Selecciona una fecha");
        return;
      }
  
      const fechaSeleccionada = new Date(fechaTurno);
      const ahora = new Date();
  
   

      // 🔹 Verificar si ya tiene un turno activo
      const q = query(
        collection(db, "appointments"),
        where("patientId", "==", user.uid)
      );
      
      const snapshot = await getDocs(q);
      
      // 👇 DEBUG
      console.log("UID ACTUAL:", user.uid);
      console.log("Cantidad de turnos:", snapshot.size);
      
      snapshot.docs.forEach(doc => {
        console.log("DOC:", doc.data());
      });
  
  
      const turnoActivo = snapshot.docs.some(doc => {
        const data = doc.data();
      
        if (!data || !data.fechaHora || !data.estado) return false;
      
        const estado = data.estado.toLowerCase().trim();
      
        const fecha = data.fechaHora.toDate
          ? data.fechaHora.toDate()
          : new Date(data.fechaHora);
      
        if (!fecha || isNaN(fecha)) return false;
      
        console.log("CHECK:", estado, fecha, fecha > ahora);
      
        return (
          (estado === "pendiente" && fecha > ahora) ||
          (estado === "confirmado" && fecha > ahora)
        );
      });
      if (turnoActivo) {
        alert("Ya tienes un turno activo.");
        return;
      }


      

  
      await addDoc(collection(db, "appointments"), {
        patientId: user.uid,
        pacienteNombre:
          `${userData?.nombre || ""} ${userData?.apellido || ""}`.trim(),
      
        fechaHora: turnoSeleccionado,
        estado: "pendiente",
        createdAt: new Date(),
      
        // Meet
        meetCreated: false,
        meetError: false,
        meetLink: null,
      
        // Recordatorios
        recordatorio24hSent: false,
        reminder2hSent: false,
      });
      
      alert("Turno solicitado");
      setFechaTurno("");
      
     
  
    } catch (error) {
      alert(error.message);
    }
  };



  const proximosTurnos = turnos
  .filter(
    (t) =>
      (t.estado === "pendiente" || t.estado === "confirmado") &&
      obtenerFecha(t.fechaHora) >= ahora
  )
  .sort(
    (a, b) => obtenerFecha(a.fechaHora) - obtenerFecha(b.fechaHora)
  );

const historialTurnos = turnos
  .filter(
    (t) =>
      !(
        (t.estado === "pendiente" || t.estado === "confirmado") &&
        obtenerFecha(t.fechaHora) >= ahora
      )
  )
  .sort(
    (a, b) => obtenerFecha(b.fechaHora) - obtenerFecha(a.fechaHora)
  );

  useEffect(() => {

    if (!pacienteSeleccionado) return;
  
    const p = pacientes[pacienteSeleccionado];
  
    if (!p) return;
  
    setPesoMedicion(p.pesoActual || "");
    setAlturaMedicion(p.altura || "");
    setGeneroMedicion(p.genero || "");
  
  }, [pacienteSeleccionado, pacientes]);
  

// 🔹 VER TURNO (PACIENTE)
useEffect(() => {
  const unsubscribeAuth = auth.onAuthStateChanged((user) => {
    if (!user) return;

    const q = query(
      collection(db, "appointments"),
      where("patientId", "==", user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const datos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      console.log("TURNOS:", datos); // 👈 IMPORTANTE

      setTurnos(datos);
    });

    return () => unsubscribe();
  });

  return () => unsubscribeAuth();
}, []);

  

// 🔹GUARDARNUTRITIPS

const guardarNutritip = async () => {
  if (!nuevoTipTitulo.trim()) {
    alert("Ingresá un título");
    return;
  }

  if (!nuevoTipTexto.trim()) {
    alert("Ingresá contenido");
    return;
  }

  try {
    await addDoc(collection(db, "nutritips"), {
      titulo: nuevoTipTitulo,
      texto: nuevoTipTexto,
      fecha: new Date(),
      activo: true
    });

    alert("Nutritip guardado");

    setNuevoTipTitulo("");
    setNuevoTipTexto("");
    setMostrarFormularioTip(false);

  } catch (error) {
    alert(error.message);
  }
};

// 🔹 ELIMINAR
const eliminarNutritip = async (id) => {
  try {
    const confirmar = window.confirm("¿Eliminar este nutritip?");
    if (!confirmar) return;

    await deleteDoc(doc(db, "nutritips", id));
    alert("Nutritip eliminado");
  } catch (error) {
    alert(error.message);
  }
};

// 🔹 EDITAR
const guardarEdicionTip = async (id) => {
  try {
    await updateDoc(doc(db, "nutritips", id), {
      titulo: nuevoTipTitulo,
      texto: nuevoTipTexto
    });

    setEditandoTip(null);
    setNuevoTipTitulo("");
    setNuevoTipTexto("");

    alert("Nutritip actualizado");
  } catch (error) {
    alert(error.message);
  }
};


// 🔹 ACTUALIZAR PESO (PACIENTE)
  
  


  const actualizarPeso = async () => {
  try {
    const user = auth.currentUser;

    // 🔹 Obtener última actualización desde legajos


    

    if (!puedeActualizarPeso(userData.lastWeightUpdate || userData.createdAt)) {
      return alert("⏳ Debes esperar para actualizar tu peso");
    }


    const alturaMetros = userData.altura / 100;
    const imc = nuevoPeso / (alturaMetros * alturaMetros);

    await addDoc(collection(db, "legajos"), {
      userId: user.uid,
      peso: Number(nuevoPeso),
      altura: userData.altura,
      imc: Number(imc.toFixed(2)),
      fecha: new Date(),
      creadoPor: "paciente"
    });
    
    // 🔥 CLAVE PARA EL SCHEDULER
    await updateDoc(doc(db, "users", user.uid), {
      peso: Number(nuevoPeso),
      lastWeightUpdate: new Date(),
      weightReminderSent: false,
    });

    // 🔹 Actualizar userData localmente
    setUserData(prev => ({ ...prev, peso: Number(nuevoPeso) }));

    alert("Peso actualizado correctamente");
    setNuevoPeso("");

    fetchLegajos();
  } catch (error) {
    console.error(error);
    alert(error.message);
  }
};


 
  // 🔹 ACTUALIZAR ESTADO TURNO
 

  const actualizarEstadoTurno = async (id, nuevoEstado, fechaTurno, esPaciente = false) => {
    try {
      if (esPaciente && nuevoEstado === "cancelado") {
        const ahora = new Date();
        const fecha = fechaTurno.seconds
          ? new Date(fechaTurno.seconds * 1000)
          : new Date(fechaTurno);
  
        const diferenciaHoras = (fecha - ahora) / (1000 * 60 * 60);
  
        if (diferenciaHoras < 24) {
          alert("Solo podés cancelar con al menos 24 horas de anticipación");
          return;
        }
      }
  
      // 🔥 ESTO ES LO IMPORTANTE
      await updateDoc(doc(db, "appointments", id), {
        estado: nuevoEstado
      });
  
    } catch (error) {
      alert(error.message);
    }
  };

  

  // 🔹 TRAER PACIENTES
  const fetchPacientes = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));
    const pacientesData = {};
  
    querySnapshot.forEach((doc) => {
      const data = doc.data();
  
      if (data.role === "paciente") {
        pacientesData[doc.id] = data;
      }
    });
  
    setPacientes(pacientesData);
  };

  // 🔹 VER LEGAJO
  const verLegajo = async (patientId) => {
    setPacienteSeleccionado(patientId);
  
    try {
      // LIMPIAR estados para evitar datos viejos
      setLegajoPaciente([]);
      setObservaciones([]);
      setDietaPaciente([]);
  
      const q = query(
        collection(db, "legajos"),
        where("userId", "==", patientId),
        orderBy("fecha", "desc")
      );
  
      const snapshot = await getDocs(q);
  
      setLegajoPaciente(
        snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      );
  
    
  
    } catch (error) {
      console.error(error);
      alert("Error al cargar legajo");
    }
  };

  // 🔹  DIETA
  useEffect(() => {
    if (!pacienteSeleccionado) return;
  
    const unsubscribe = onSnapshot(collection(db, "dietas"), (snapshot) => {
      const datos = snapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(d => 
          d.patientId === pacienteSeleccionado || 
          d.userId === pacienteSeleccionado
        );
  
      setDietas(datos);
    });
  
    return () => unsubscribe();
  }, [pacienteSeleccionado]);

  // 🔹 GUARDAR DIETA PDF
  const guardarDieta = async (patientId) => {
    if (!nuevaDietaUrl) { alert("Ingresa el link del PDF"); return; }
    if (!nuevoNombreDieta) { alert("Ingresa un nombre para la dieta"); return; }
  
    try {
      setGuardandoDieta(true);
  
      await addDoc(collection(db, "dietas"), {
        patientId: patientId,
        url: nuevaDietaUrl,
        nombreArchivo: nuevoNombreDieta,
        fecha: new Date(),
        creadoPor: "nutricionista"
      });
  
      setDietaOk(true);
  
      alert("Dieta guardada");
  
      setNuevaDietaUrl("");
      setNuevoNombreDieta("");
  
      setTimeout(() => setDietaOk(false), 2000);
  
    } catch (error) {
      alert(error.message);
    } finally {
      setGuardandoDieta(false);
    }
  };
    // 🔹 ELIMINAR DIETA PDF

  const eliminarDieta = async (id) => {
    try {
      const confirmar = window.confirm("¿Seguro que querés eliminar esta dieta?");
      if (!confirmar) return;
  
      await deleteDoc(doc(db, "dietas", id));
  
      alert("Dieta eliminada");
    } catch (error) {
      console.error(error);
      alert("Error al eliminar dieta");
    }
  };

// 🔹 OBSERVACIONES EN TIEMPO REAL
// 🔹 CARGAR OBSERVACIONES EXISTENTES
// 🔹 OBSERVACIONES EN TIEMPO REAL (viejas y nuevas)
useEffect(() => {
  if (!pacienteSeleccionado) return;

  const unsubscribe = onSnapshot(collection(db, "observaciones"), (snapshot) => {
    const datos = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(d => 
        d.patientId === pacienteSeleccionado || d.userId === pacienteSeleccionado
      )
      .sort((a, b) => {
        const fechaA = a.fecha?.seconds ? new Date(a.fecha.seconds * 1000) : new Date(a.fecha);
        const fechaB = b.fecha?.seconds ? new Date(b.fecha.seconds * 1000) : new Date(b.fecha);
        return fechaB - fechaA; // las más recientes primero
      });

    console.log("OBSERVACIONES TRAIDAS:", datos);
    setObservaciones(datos);
  });

  return () => unsubscribe();
}, [pacienteSeleccionado]);




const guardarObservacion = async (patientId, texto) => {
  if (!texto.trim()) return alert("Escribe una observación");

  await addDoc(collection(db, "observaciones"), {
    patientId,       // 🔹 clave correcta
    texto,
    fecha: new Date()
  });

  setNuevaObservacion("");
};

const actualizarObservacion = async (id, texto) => {
  try {
    const ref = doc(db, "observaciones", id);
    await updateDoc(ref, { texto });
    setObservacionEditando(null);
    setNuevaObservacion("");
  } catch (error) {
    console.error("Error al actualizar:", error);
  }
};

const eliminarObservacion = async (id) => {
  try {
    const confirmar = window.confirm("¿Eliminar esta observación?");
    if (!confirmar) return;

    await deleteDoc(doc(db, "observaciones", id));
    // onSnapshot se encarga de actualizar automáticamente
  } catch (error) {
    console.error(error);
    alert("Error al eliminar observación");
  }
};


  // 🔹 GUARDAR GUIA 


const guardarGuia = async () => {
  try {
    await addDoc(collection(db, "guiaMedicion"), {
      titulo: "Guía de medición",
      url: guiaUrl,
      createdAt: new Date()
    });

    alert("Guía guardada");
    setGuiaUrl("");
  } catch (error) {
    alert(error.message);
  }
};

  // 🔹 UTIL: FORMATEAR FECHA
  const formatFecha = (fecha) => {
    if (!fecha) return "";
  
    const date = fecha.seconds 
      ? new Date(fecha.seconds * 1000) 
      : new Date(fecha);
  
    return date.toLocaleDateString();
  };

  // 🔹 Función para mostrar fecha y hora en 24h
const formatFechaHora24 = (fechaHora) => {
  if (!fechaHora) return "";

  const date = fechaHora.toDate ? fechaHora.toDate() : new Date(fechaHora);
  const fecha = date.toLocaleDateString();
  const hora = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  return `${fecha} ${hora}`;
};


  // 🔹 turnos filtro

const obtenerTurnosFiltrados = () => {
  const ahora = new Date();

  return turnos.filter(t => {
    const fecha = t.fechaHora.toDate
      ? t.fechaHora.toDate()
      : new Date(t.fechaHora.seconds * 1000);

      if (filtro === "futuros") {
        return (
          (t.estado === "pendiente" || t.estado === "confirmado") &&
          fecha >= ahora
        );
      }
    if (filtro === "pasados") return fecha < ahora;
    if (filtro === "pendientes") return t.estado === "pendiente";
    if (filtro === "confirmados") return t.estado === "confirmado";
    if (filtro === "cancelados") return t.estado === "cancelado";

    return true;
  }).sort((a, b) => {
    const fechaA = a.fechaHora.toDate ? a.fechaHora.toDate() : new Date(a.fechaHora.seconds * 1000);
    const fechaB = b.fechaHora.toDate ? b.fechaHora.toDate() : new Date(b.fechaHora.seconds * 1000);

    return filtro === "pasados" ? fechaB - fechaA : fechaA - fechaB;
  });
};


 // 🔹 UTIL: COLOR SEGÚN ESTADO
 const getEstadoColor = (estado) => {
    switch (estado) {
      case "confirmado":
        return "#22c55e"; // verde suave (NO igual al botón)
      case "pendiente":
        return "#f59e0b"; // amarillo
      case "cancelado":
        return "#ef4444"; // rojo
      default:
        return "#64748b"; // gris
    }
  };

  

const imcInicial = userData?.pesoInicial && userData?.altura
  ? (userData.pesoInicial / ((userData.altura / 100) ** 2)).toFixed(2)
  : null;


  const traerMediciones = async (uid) => {

    try {
  
      const q = query(
        collection(db, "mediciones"),
        where("userId", "==", uid)
      );
  
      const snap = await getDocs(q);
  
      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
  
      // ordenar más nuevas primero
      data.sort((a, b) => {
  
        const fechaA =
          a.fecha?.seconds
            ? a.fecha.seconds
            : 0;
  
        const fechaB =
          b.fecha?.seconds
            ? b.fecha.seconds
            : 0;
  
        return fechaB - fechaA;
      });
  
      setHistorialMediciones(data);
  
    } catch (error) {
  
      console.error(error);
    }
  };
  
  
  

 // 🔹 UTIL: MEDICION

 const guardarMedicion = async () => {
  try {

    if (!pacienteSeleccionado) {
      return alert("Seleccioná un paciente");
    }

    const paciente = pacientes[pacienteSeleccionado];

    const genero = paciente?.genero || "";
    const edad = calcularEdad(paciente?.fechaNacimiento);

    const pesoAnterior = Number(paciente?.pesoActual || 0);
    const pesoNuevo = Number(pesoMedicion);

    const pesoCambio = pesoNuevo !== pesoAnterior;

    const altura = Number(alturaMedicion);
    const alturaMetros = altura / 100;

    const cintura = Number(cinturaMedicion || 0);
    const cadera = Number(caderaMedicion || 0);
    const cuello = Number(cuelloMedicion || 0);

    const pecho = Number(pechoMedicion || 0);
    const brazo = Number(brazoMedicion || 0);

    // ================= IMC =================

    const imc =
      pesoNuevo / (alturaMetros * alturaMetros);

    // ================= ICC =================

    const icc =
      cadera > 0
        ? cintura / cadera
        : 0;

    // ================= ICA =================

    const ica =
      altura > 0
        ? cintura / altura
        : 0;

         // ================= % GRASA VISCERAL =================

         const grasaVisceral = Math.round(ica * 25);


 // ================= % GRASA =================   /

let grasaCorporal = 0;

// 🔥 convertir a pulgadas
const cinturaIn = cintura / 2.54;
const caderaIn = cadera / 2.54;
const cuelloIn = cuello / 2.54;
const alturaIn = altura / 2.54;

if (
  genero === "hombre" &&
  cintura > 0 &&
  cuello > 0
) {

  grasaCorporal =
    86.01 *
      Math.log10(cinturaIn - cuelloIn) -
    70.041 *
      Math.log10(alturaIn) +
    36.76;

} else if (
  genero === "mujer" &&
  cintura > 0 &&
  cadera > 0 &&
  cuello > 0
) {

  grasaCorporal =
    163.205 *
      Math.log10(
        cinturaIn +
        caderaIn -
        cuelloIn
      ) -
    97.684 *
      Math.log10(alturaIn) -
    78.387;
}

// evitar negativos raros
grasaCorporal = Math.max(grasaCorporal, 0);

    // ================= MASA GRASA =================

    const masaGrasa =
      (pesoNuevo * grasaCorporal) / 100;

    // ================= MASA MAGRA =================

    const masaMagra =
      pesoNuevo - masaGrasa;

    // ================= TMB =================

    let tmb = 0;

    if (genero === "hombre") {

      tmb =
        (10 * pesoNuevo) +
        (6.25 * altura) -
        (5 * edad) +
        5;

    } else if (genero === "mujer") {

      tmb =
        (10 * pesoNuevo) +
        (6.25 * altura) -
        (5 * edad) -
        161;
    }

    const userRef =
      doc(db, "users", pacienteSeleccionado);

    // ==================================================
    // SOLO SI CAMBIÓ EL PESO
    // ==================================================

    if (pesoCambio) {

      // 🔵 LEGAJO PESO
      await addDoc(collection(db, "legajos"), {
        userId: pacienteSeleccionado,
        peso: pesoNuevo,
        altura: altura,
        imc: Number(imc.toFixed(2)),
        fecha: new Date(),
        creadoPor: "nutricionista"
      });

      // 🔵 UPDATE USER
      await updateDoc(userRef, {
        pesoActual: pesoNuevo,
        altura: altura,
        lastWeightUpdate: new Date()
      });
    }

    // ==================================================
    // MEDICIÓN SIEMPRE
    // ==================================================

    await addDoc(collection(db, "mediciones"), {

      userId: pacienteSeleccionado,

      genero,
      edad,

      peso: pesoNuevo,
      altura,

      cintura,
      cadera,
      cuello,
      pecho,
      brazo,

      imc: Number(imc.toFixed(2)),

      icc: Number(icc.toFixed(2)),
      ica: Number(ica.toFixed(2)),

      grasaVisceral: grasaVisceral,

      grasaCorporal:
        Number(grasaCorporal.toFixed(2)),

      masaGrasa:
        Number(masaGrasa.toFixed(2)),

      masaMagra:
        Number(masaMagra.toFixed(2)),

      tmb:
        Number(tmb.toFixed(0)),

      observaciones:
        observacionesMedicion || "",

      fecha: new Date(),

      creadoPor: "nutricionista"
    });

    alert("Medición guardada correctamente");

    // refrescar cards
    traerMediciones(pacienteSeleccionado);

  } catch (error) {

    console.error(error);

    alert(error.message);
  }
};




  const fechaSeleccionada = fechaTurno ? new Date(fechaTurno) : null;

  const obtenerHorariosDisponibles = (fechaSeleccionada, turnos, bloqueados) => {
    const horarios = [8,9,10,11,12,13,14,15,16,17,18,19,20];
  
    if (!fechaSeleccionada) return [];
  
    const dia = fechaSeleccionada.getDay();
  
    // ❌ bloquear domingos
    if (dia === 0) return [];
  
    const fechaString = fechaSeleccionada.toISOString().split("T")[0];
  
    // ❌ día bloqueado por el nutricionista
    if (bloqueados.includes(fechaString)) return [];
  
    return horarios.filter(hora => {
      const ahora = new Date();
    
      // 🔥 construir fecha completa con la hora
      const fechaHora = new Date(
        fechaSeleccionada.getFullYear(),
        fechaSeleccionada.getMonth(),
        fechaSeleccionada.getDate(),
        hora,
        0
      );
    
      // 🔥 VALIDACIÓN 12 HORAS
      const esValido = (fechaHora - ahora) >= 12 * 60 * 60 * 1000;
      if (!esValido) return false;
      // 1️⃣ Ver si el nutricionista bloqueó este horario
      const bloqueado = horariosBloqueados[fechaString]?.includes(hora);
      if (bloqueado) return false;
    
      // 2️⃣ Ver si el turno ya está ocupado
      return !turnos.some(t => {
        if (!t.fechaHora) return false;
    
        const fecha = t.fechaHora.toDate
          ? t.fechaHora.toDate()
          : new Date(t.fechaHora);
    
        return (
          fecha.toISOString().split("T")[0] === fechaString &&
          fecha.getHours() === hora &&
          t.estado !== "cancelado"
        );
      });
    });
  };

  const horariosDisponibles = fechaSeleccionada
  ? obtenerHorariosDisponibles(fechaSeleccionada, turnos, diasBloqueados)
  : [];

// 🔹 efecto para actualizar el ancho al redimensionar
useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  useEffect(() => {
    if (userData?.role === "nutricionista") {
      // 🔹 Creamos la query y ordenamos por fechaHora
      const q = query(collection(db, "appointments"), orderBy("fechaHora"));
  
      // 🔹 Escuchamos los cambios en tiempo real
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const turnosData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  
        // 🔹 Ordenar por fecha por si acaso
        turnosData.sort((a, b) => {
          const fechaA = a.fechaHora?.seconds ? new Date(a.fechaHora.seconds * 1000) : new Date(a.fechaHora);
          const fechaB = b.fechaHora?.seconds ? new Date(b.fechaHora.seconds * 1000) : new Date(b.fechaHora);
          return fechaA - fechaB;
        });
  
        setTurnos(turnosData);
      });
  
      // 🔹 Cleanup al desmontar el componente
      return () => unsubscribe();
    }
  }, [userData]);

  // 🔹 LOADING
  if (!userData)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          color: "white"
        }}
      >
        <img
          src="/logo512sinfondo.png"
          alt="RNutricion"
          style={{
            width: "120px",
            height: "120px",
            objectFit: "contain",
            animation:
              "spinReverse 6s linear infinite"
          }}
        />
  
        <p
          style={{
            marginTop: "20px",
            fontSize: "18px",
            fontWeight: 500,
            opacity: 0.9
          }}
        >
          Cargando RNutricion...
        </p>
  
        <style>
          {`
           @keyframes spinReverse {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
          `}
        </style>
      </div>
    );
  


  return (
    <>


    
      {/* BOTÓN HAMBURGUESA */}
      {screenWidth < 768 && userData.role === "nutricionista" && (
  <button
    onClick={() => setMostrarMenu(!mostrarMenu)}
    style={{
      position: "absolute",
      bottom: "100px",
      left: "0px",
      zIndex: 10,
      background: colors.primary,
      border: "none",
      padding: "2px 4px",
      borderRadius: "6px",
      color: "white",
      cursor: "pointer",
      fontSize: "22px",

      opacity: mostrarBoton ? 1 : 0, // 🔥 animación
      pointerEvents: mostrarBoton ? "auto" : "none",
      transition: "opacity 0.3s"
    }}
  >
    ☰
  </button>
)}



      {/* TODO EL CONTENIDO */}
      <div
  style={{
    display: "flex",
    flexDirection: "row",
    position: "relative",
    
    width: "100%",
    fontFamily: "Arial",
    overflowX: "hidden"
  }}

>
 

 
  {/* PANEL NUTRICIONISTA */}
{userData.role === "nutricionista" && (
  <div style={{
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  width: "100%",
  
}}>



{/* SIDEBAR */}
<div
  onClick={(e) => e.stopPropagation()}
  style={{
    width: screenWidth >= 1024 ? "250px" : "250px", // 👈 más ancho en móvil
  
    backgroundColor: "#0f172a",
    color: "white",
  
    padding: screenWidth >= 1024 ? "30px 15px" : "28px 22px", // 👈 más aire
  
    display: "flex",
    flexDirection: "column",
  
    gap: screenWidth < 768 ? "18px" : "12px", // 👈 más separación
  
    position: screenWidth < 768 ? "fixed" : "relative",
    top: 0,
    left: screenWidth < 768 ? (mostrarMenu ? "0" : "-100%") : "0",
  
    height: "96dvh",
paddingBottom: "env(safe-area-inset-bottom)",
overflowY: "auto",
    minHeight: 0,
  
    transition: "left 0.3s ease",
    boxShadow: screenWidth < 768
      ? "2px 0 14px rgba(0,0,0,0.3)"
      : "none",
  
    zIndex: 1001,
  }}
>

<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flex: 1,
    overflowY: "auto",
  }}
>

<button
  onClick={() => {
    setTab("turnos");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
  
    borderRadius: "12px",
    border: "none",
  
    background: tab === "turnos" ? "#3b82f6" : "rgba(255,255,255,0.03)",
  
    color: "white",
    cursor: "pointer",
  
    fontSize: screenWidth >= 1024 ? "30px" : "30px", // 👈 más grande
  
    fontWeight: 500,
  
    textAlign: "center", // 👈 centrado real
  
    minHeight: screenWidth < 768 ? "56px" : "auto",
  
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // 👈 CENTRADO PERFECTO
  
    letterSpacing: "0.2px",
  }}
>
  📅 Turnos
</button>

<button
  onClick={() => {
    setTab("pacientes");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
  
    borderRadius: "12px",
    border: "none",
  
    background: tab === "pacientes" ? "#3b82f6" : "rgba(255,255,255,0.03)",
  
    color: "white",
    cursor: "pointer",
  
    fontSize: screenWidth >= 1024 ? "30px" : "30px", // 👈 más grande
  
    fontWeight: 500,
  
    textAlign: "center", // 👈 centrado real
  
    minHeight: screenWidth < 768 ? "56px" : "auto",

  
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // 👈 CENTRADO PERFECTO
  
    letterSpacing: "0.2px",
  }}
>
  👥 Pacientes
</button>

<button
  onClick={() => {
    setTab("calendario");
    if (screenWidth < 768) setMostrarMenu(false); // 🔥 importante (te faltaba)
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
  
    borderRadius: "12px",
    border: "none",
  
    background: tab === "calendario" ? "#3b82f6" : "rgba(255,255,255,0.03)",
  
    color: "white",
    cursor: "pointer",
  
    fontSize: screenWidth >= 1024 ? "30px" : "30px", // 👈 más grande
  
    fontWeight: 500,
  
    textAlign: "center", // 👈 centrado real
  
    minHeight: screenWidth < 768 ? "56px" : "auto",
  
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // 👈 CENTRADO PERFECTO
  
    letterSpacing: "0.2px",
  }}
>
  📆 Calendario
</button>

<button
  onClick={() => {
    setTab("noticias");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
    borderRadius: "12px",
    border: "none",
    background: tab === "noticias" ? "#3b82f6" : "rgba(255,255,255,0.03)",
    color: "white",
    cursor: "pointer",
    fontSize: "30px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
>
  📰 Noticias
</button>


<button
  onClick={() => {
    setTab("nutritips");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
    borderRadius: "12px",
    border: "none",
    background: tab === "nutritips" ? "#3b82f6" : "rgba(255,255,255,0.03)",
    color: "white",
    cursor: "pointer",
    fontSize: "30px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
>
  💡 Nutritips
</button>

<button
  onClick={() => {
    setTab("guia");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
    borderRadius: "12px",
    border: "none",
    background: tab === "guia" ? "#3b82f6" : "rgba(255,255,255,0.03)",
    color: "white",
    cursor: "pointer",
    fontSize: "30px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
>
📚 Guías
</button>

<button
  onClick={() => {
    setTab("medicion");
    if (screenWidth < 768) setMostrarMenu(false);
  }}
  style={{
    padding: screenWidth >= 1024 ? "14px 12px" : "18px 16px",
    borderRadius: "12px",
    border: "none",
    background: tab === "medicion" ? "#3b82f6" : "rgba(255,255,255,0.03)",
    color: "white",
    cursor: "pointer",
    fontSize: "30px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
>
  📊 Medición
</button>


</div>

<button
    onClick={() => {
      const confirmar = window.confirm("¿Seguro que quieres cerrar sesión?");
      if (confirmar) handleLogout();
    }}
    style={{
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.15)",
      border: "1px solid rgba(255,255,255,0.25)",
      color: "white",
      fontSize: "15px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      lineHeight: "1",
      transition: "0.2s"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.3)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.15)";
    }}
  >
    ✕
  </button>

<div
  style={{
   
    paddingTop: "15px",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
  }}
>
  <img
    src="logo512sinfondo.png"
    alt="NutriApp logo"
    style={{
      width: screenWidth >= 1024 ? "60px" : "60px",
      height: screenWidth >= 1024 ? "60px" : "54px",
      objectFit: "cover",
      borderRadius: "8px"
    }}
  />

  <h2
    style={{
      margin: 0,
      fontSize: screenWidth >= 1024 ? "18px" : "16px",
      fontWeight: 700,
      color: "white"
    }}
  >
    RNutricion 
  </h2>


  <span
  style={{
    marginLeft: "auto", // 🔥 ESTO LO EMPUJA A LA DERECHA
    fontSize: "18px",
    fontWeight: 600
  }}
>
  ®
</span>
  
</div>

    </div>

  


    {/* OVERLAY PARA CERRAR SIDEBAR AL HACER CLICK FUERA */}
    {screenWidth < 768 && mostrarMenu && (
      <div
        onClick={() => setMostrarMenu(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1000
        }}
      ></div>
    )}

   {/* CONTENIDO */}
   <div
  ref={contentRef} // 🔥 ESTA LÍNEA ES LA CLAVE
  style={{
    flex: 1,
    padding: "25px",
    paddingTop: screenWidth < 768 ? "60px" : "25px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
    color: isDark ? "white" : "black",

    overflowY: "auto",   // 🔥 ESTO ES LA CLAVE
  }}
>
 




  
      {/* ================= TAB TURNOS ================= */}
      {tab === "turnos" && (
        
  <>
  
  <h2>Turnos</h2>
    <hr style={{ marginBottom: "20px" }} />


    <input
  type="text"
  placeholder="🔍 Buscar turno..."
  value={busquedaTurno}
  onChange={(e) =>
    setBusquedaTurno(e.target.value)
  }
  style={{
    width: "100%",
    maxWidth: "260px",
    padding: "8px 10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    margin: "0 auto 15px auto",
    display: "block",
    boxSizing: "border-box",
    fontSize: "13px"
  }}
/>

<div
  style={{
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
    justifyContent: "center",
    flexWrap: "wrap"
  }}
>
  {/* AÑO */}
  <select
    value={filtroAnio}
    onChange={(e) =>
      setFiltroAnio(Number(e.target.value))
    }
    style={{
      padding: "8px",
      borderRadius: "8px",
      border: "1px solid #cbd5e1"
    }}
  >
    {[2026, 2027, 2028].map((a) => (
      <option key={a} value={a}>
        Año {a}
      </option>
    ))}
  </select>

  {/* MES */}
  <select
    value={filtroMes}
    onChange={(e) =>
      setFiltroMes(Number(e.target.value))
    }
    style={{
      padding: "8px",
      borderRadius: "8px",
      border: "1px solid #cbd5e1"
    }}
  >
    {[
      "Enero","Febrero","Marzo","Abril",
      "Mayo","Junio","Julio","Agosto",
      "Septiembre","Octubre","Noviembre","Diciembre"
    ].map((m, i) => (
      <option key={i} value={i + 1}>
        {m}
      </option>
    ))}
  </select>
</div>
    
 

    {/* 🔹 Filtros */}
    <div style={{ marginBottom: "15px" }}>
  {[
    { key: "futuros", label: "📅 Próximos" },
    { key: "pasados", label: "🕘 Pasados" },
    { key: "pendientes", label: "⏳ Pendientes" },
    { key: "confirmados", label: "✔ Confirmados" },
    { key: "cancelados", label: "✖ Cancelados" }
  ].map(item => (
    <div
      key={item.key}
      onClick={() => setFiltro(item.key)}
      style={{
        padding: "10px 12px",
        cursor: "pointer",
        borderRadius: "6px",
        marginBottom: "5px",
        fontWeight: "500",
        transition: "0.2s",

        background:
          filtro === item.key
            ? "#10b981"
            : isDark
            ? "#1e293b"
            : "#f8fafc",

        color:
          filtro === item.key
            ? "white"
            : isDark
            ? "#e2e8f0"
            : "#111",

        border:
          filtro === item.key
            ? "1px solid #059669"
            : "1px solid #e2e8f0"
      }}
    >
      {item.label}
    </div>
  ))}
</div>

<h3 style={{ marginBottom: "10px" }}>
  {filtro === "futuros" && "Turnos próximos"}
  {filtro === "pasados" && "Turnos pasados"}
  {filtro === "pendientes" && "Turnos pendientes"}
  {filtro === "confirmados" && "Turnos confirmados"}
  {filtro === "cancelados" && "Turnos cancelados"}
</h3>

    {/* 🔹 LISTA FILTRADA */}
    {obtenerTurnosFiltrados().length === 0 ? (
      <p>No hay turnos</p>
    ) : (
      obtenerTurnosFiltrados()

      .filter((t) => {
        const paciente =
          pacientes?.[t.patientId];
      
        const texto = `
          ${paciente?.nombre || ""}
          ${paciente?.apellido || ""}
          ${paciente?.telefono || ""}
          ${paciente?.email || ""}
        `.toLowerCase();
      
        const coincideTexto = texto.includes(
          busquedaTurno.toLowerCase()
        );
      
        const fecha = t.fechaHora.toDate
          ? t.fechaHora.toDate()
          : new Date(t.fechaHora.seconds * 1000);
      
        const año = fecha.getFullYear();
        const mes = fecha.getMonth() + 1;
      
        const coincideFecha =
          año === filtroAnio &&
          mes === filtroMes;
      
        return coincideTexto && coincideFecha;
      })
      
      .map((t) => {        const fecha = t.fechaHora.toDate

    ? t.fechaHora.toDate()

    : new Date(t.fechaHora.seconds * 1000);

  const esPasado = fecha < new Date();
  const bloquearConfirmar =
  esPasado ||
  t.estado === "confirmado" ||
  t.estado === "cancelado";

const bloquearCancelar =
  esPasado ||
  t.estado === "cancelado";
  
        return (
          <div key={t.id} style={{
            background: isDark ? "#0f172a" : "white",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            marginBottom: "10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
          }}>
            <p>
              <strong>Paciente:</strong>{" "}
              {pacientes[t.patientId]?.nombre} {pacientes[t.patientId]?.apellido}
            </p>

            <p>
              <strong>Estado:</strong>{" "}
              <span style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "5px 10px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "bold",
                background:
                  t.estado === "confirmado"
                    ? "#dcfce7"
                    : t.estado === "cancelado"
                    ? "#fee2e2"
                    : "#fef3c7",
                color:
                  t.estado === "confirmado"
                    ? "#166534"
                    : t.estado === "cancelado"
                    ? "#991b1b"
                    : "#92400e"
              }}>
                {t.estado === "confirmado" && "✔"}
                {t.estado === "cancelado" && "✖"}
                {t.estado === "pendiente" && "⏳"}
                {t.estado.toUpperCase()}
              </span>
            </p>

            <p>📅 {formatFechaHora24(t.fechaHora)}</p>

            <div style={{ marginTop: "10px" }}>

              

              
            <button
  disabled={bloquearConfirmar}
  onClick={() => {
    if (window.confirm("¿Seguro que deseas confirmar el turno?")) {
      actualizarEstadoTurno(t.id, "confirmado");
    }
  }}
  style={{
    flex: 1,
    border: "none",
    background: bloquearConfirmar ? "#94a3b8" : "#10b981",
    color: "white",
    padding: "11px",
    borderRadius: "10px",
    fontWeight: "600",
    cursor: bloquearConfirmar ? "not-allowed" : "pointer",
    opacity: bloquearConfirmar ? 0.6 : 1
  }}
>
  Confirmar
</button>

<button
  disabled={bloquearCancelar}
  onClick={() => {
    if (window.confirm("¿Seguro que deseas cancelar el turno?")) {
      actualizarEstadoTurno(t.id, "cancelado");
    }
  }}
  style={{
    flex: 1,
    border: "none",
    background: bloquearCancelar ? "#94a3b8" : "#ef4444",
    color: "white",
    padding: "11px",
    borderRadius: "10px",
    marginLeft: "8px",

    fontWeight: "600",
    cursor: bloquearCancelar ? "not-allowed" : "pointer",
    opacity: bloquearCancelar ? 0.6 : 1
  }}
>
  Cancelar
</button>
</div>
          </div>
        );
      })
    )}
  </>
)}

      {/* ================= PACIENTES ================= */}
{tab === "pacientes" && (
  <>
    <h2 style={{ marginBottom: "5px" }}>👥 Pacientes</h2>
    <p style={{ fontSize: "13px", color: "gray", marginBottom: "15px" }}>
      Gestión y seguimiento de pacientes
    </p>

    <input
  type="text"
  placeholder="🔍 Buscar paciente..."
  value={busquedaPaciente}
  onChange={(e) =>
    setBusquedaPaciente(e.target.value)
  }
  style={{
    width: "100%",
    maxWidth: "260px",
    padding: "8px 10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    margin: "0 auto 12px auto",
    display: "block",
    boxSizing: "border-box",
    fontSize: "13px"
  }}
/>

    {Object.keys(pacientes).length === 0 ? (
      <p>No hay pacientes</p>
    ) : (
      <div
        style={{
          padding: "10px",
          maxWidth: "400px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}
      >
        {Object.entries(pacientes)
          .filter(([id, p]) => {

            if (p.role !== "paciente")
              return false;
          
            const texto = `
              ${p.nombre || ""}
              ${p.apellido || ""}
              ${p.dni || ""}
              ${p.telefono || ""}
              ${p.email || ""}
            `.toLowerCase();
          
            return texto.includes(
              busquedaPaciente.toLowerCase()
            );
          })
          
          .sort((a, b) => {
          
            const nombreA =
              `${a[1].nombre || ""} ${a[1].apellido || ""}`
                .toLowerCase();
          
            const nombreB =
              `${b[1].nombre || ""} ${b[1].apellido || ""}`
                .toLowerCase();
          
            return nombreA.localeCompare(nombreB);
          
          })
          .map(([id, p]) => (
            
            <div
              key={id}
              onClick={() => {
                if (pacienteSeleccionado !== id) {
                  setPacienteSeleccionado(id);
                  verLegajo(id);
                }
              }}
              style={{
                background: pacienteSeleccionado === id
                  ? colors.cardSoft
                  : colors.card,

                padding: "16px",
                borderRadius: "14px",

                border: pacienteSeleccionado === id
                  ? `2px solid ${colors.primary}`
                  : `1px solid ${colors.border}`,

                boxShadow: pacienteSeleccionado === id
                  ? "0 6px 18px rgba(0,0,0,0.12)"
                  : "0 2px 6px rgba(0,0,0,0.06)",

                position: "relative",
                transition: "all 0.2s"
              }}
            >

              {/* ✔ INDICADOR */}
              {pacienteSeleccionado === id && (
                <div style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: colors.primary,
                  color: "white",
                  borderRadius: "50%",
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold"
                }}>
                  ✓
                </div>
              )}

{/* 🔥 HEADER */}
<div style={{ marginBottom: "8px" }}>
  <p style={{
    fontSize: "18px",
    fontWeight: "600",
    margin: 0
  }}>
    {p.nombre} {p.apellido}
  </p>
</div>

{/* 🔥 DATOS */}
<div style={{
  fontSize: "13px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  color: "#334155"
}}>
  <span>DNI: {p.dni}</span>
  <span>
  FECHA NAC: {p.fechaNacimiento || "N/A"}
</span>


<span>
  EDAD: {calcularEdad(p.fechaNacimiento)} años
</span>

  <span>PESO: {p.pesoActual} kg</span>
  <span>ALTURA: {p.altura} cm</span>
</div>

{/* 🔥 TELEFONO */}
<div style={{
  marginTop: "8px",
  fontSize: "12px",
  color: "#64748b"
}}>

  {editandoTelefono === id ? (
    <>
      <input
        type="text"
        inputMode="numeric"
        value={nuevoTelefono}
        onChange={(e) => {
          let v = e.target.value.replace(/\D/g, "").slice(0, 10);
          setNuevoTelefono(v);
        }}
        placeholder="Nuevo teléfono"
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #cbd5e1",
          marginBottom: "8px",
          fontSize: "13px"
        }}
      />

      <div style={{ display: "flex", gap: "8px" }}>

        <button
          disabled={
            !nuevoTelefono.trim() ||
            nuevoTelefono.trim() === (p.telefono || "").trim()
          }
          onClick={() => {
            if (
              window.confirm(
                `¿Seguro que deseas cambiar el teléfono de:\n\n${p.telefono}\n\na:\n\n${nuevoTelefono}?`
              )
            ) {
              guardarTelefono(id);
            }
          }}
          style={{
            padding: "8px 12px",
            border: "none",
            borderRadius: "8px",
            background:
              !nuevoTelefono.trim() ||
              nuevoTelefono.trim() === (p.telefono || "").trim()
                ? "#94a3b8"
                : "#16a34a",
            color: "white",
            cursor:
              !nuevoTelefono.trim() ||
              nuevoTelefono.trim() === (p.telefono || "").trim()
                ? "not-allowed"
                : "pointer",
            fontWeight: "600",
            opacity:
              !nuevoTelefono.trim() ||
              nuevoTelefono.trim() === (p.telefono || "").trim()
                ? 0.7
                : 1
          }}
        >
          Guardar
        </button>

        <button
          onClick={() => {
            setEditandoTelefono(null);
            setNuevoTelefono("");
          }}
          style={{
            padding: "8px 12px",
            border: "none",
            borderRadius: "8px",
            background: "#ef4444",
            color: "white",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          X
        </button>

      </div>
    </>
  ) : (
    <>
      📱 {p.telefono}

      <button
        onClick={() => {
          setEditandoTelefono(id);
          setNuevoTelefono(p.telefono || "");
        }}
        style={{
          marginLeft: "10px",
          border: "none",
          background: "transparent",
          color: "#2563eb",
          cursor: "pointer"
        }}
      >
        Cambiar Teléfono
      </button>

      {/* 🔥 WHATSAPP */}
      {p.telefono && (
        <a
          href={`https://wa.me/54${p.telefono}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginLeft: "10px",
            color: "#16a34a",
            fontWeight: "600",
            textDecoration: "none"
          }}
        >
          WhatsApp
        </a>
      )}
    </>
  )}
</div>

{/* 🔥 EMAIL */}

<div style={{
  marginTop: "8px",
  fontSize: "12px",
  color: "#64748b"
}}>

  
  {editandoEmail === id ? (
   <>
   <input
     type="email"
     value={nuevoEmail}
     onChange={(e) => setNuevoEmail(e.target.value)}
     placeholder="Nuevo email"
     style={{
       width: "100%",
       boxSizing: "border-box",
       padding: "10px",
       borderRadius: "8px",
       border: "1px solid #cbd5e1",
       marginBottom: "8px",
       fontSize: "13px"
     }}
   />
 
   <div style={{ display: "flex", gap: "8px" }}>

    
 
   <button
  disabled={
    !nuevoEmail.trim() ||
    nuevoEmail.trim() === (p.email || "").trim()
  }
  onClick={() => {
    if (
      window.confirm(
        `¿Seguro que deseas cambiar el email de:\n\n${p.email}\n\na:\n\n${nuevoEmail}?`
      )
    ) {
      guardarEmail(id);
    }
  }}
  style={{
    padding: "8px 12px",
    border: "none",
    borderRadius: "8px",
    background:
      !nuevoEmail.trim() ||
      nuevoEmail.trim() === (p.email || "").trim()
        ? "#94a3b8"
        : "#16a34a",
    color: "white",
    cursor:
      !nuevoEmail.trim() ||
      nuevoEmail.trim() === (p.email || "").trim()
        ? "not-allowed"
        : "pointer",
    fontWeight: "600",
    opacity:
      !nuevoEmail.trim() ||
      nuevoEmail.trim() === (p.email || "").trim()
        ? 0.7
        : 1
  }}
>
  Guardar
</button>
 
     <button
       onClick={() => {
         setEditandoEmail(null);
         setNuevoEmail("");
       }}
       style={{
         padding: "8px 12px",
         border: "none",
         borderRadius: "8px",
         background: "#ef4444",
         color: "white",
         cursor: "pointer",
         fontWeight: "600"
       }}
     >
       X
     </button>
 
   </div>
 </>
  ) : (
    <>
      📧 {p.email}

      <button
        onClick={() => {
          setEditandoEmail(id);
          setNuevoEmail(p.email || "");
        }}
        style={{
          marginLeft: "10px",
          border: "none",
          background: "transparent",
          color: "#2563eb",
          cursor: "pointer"
        }}
      >
        Cambiar Email
      </button>
    </>
  )}
</div>


            

                    {/* DETALLE */}
{pacienteSeleccionado === id && (
  <div style={{
    marginTop: "15px",
    padding: "16px",
    background: isDark ? "#020617" : "#f8fafc",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  }}>

    <h4 style={{ margin: 0 }}>📊 Detalle del paciente</h4>

    {/* ================= HISTORIAL ================= */}
    <div>
      <strong style={{ fontSize: "14px" }}>Historial</strong>

      <div style={{
  marginTop: "6px",
  padding: "10px",
  background: "#ecfdf5",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#065f46"
}}>
  🟢 Peso inicial: {pacientes[id]?.pesoInicial} kg

  {" - IMC: "}
  {pacientes[id]?.pesoInicial && pacientes[id]?.altura
    ? (pacientes[id].pesoInicial / ((pacientes[id].altura / 100) ** 2)).toFixed(2)
    : "N/A"}

  {/* 📅 FECHA usando createdAt */}
  {pacientes[id]?.createdAt && (
    <div style={{ marginTop: "4px", fontSize: "12px", color: "#047857" }}>
      📅 {formatFecha(
        pacientes[id].createdAt.seconds
          ? new Date(pacientes[id].createdAt.seconds * 1000)
          : pacientes[id].createdAt
      )}
    </div>
  )}
</div>

      {/* 🔹 Historial listado */}
      <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "4px" }}>
        {legajoPaciente.map(l => (
          <div key={l.id} style={{
            fontSize: "13px",
            padding: "6px 8px",
            borderRadius: "6px",
            background: isDark ? "#020617" : "#ffffff",
            border: "1px solid #e2e8f0"
          }}>
            📅 {formatFecha(l.fecha)} — {l.peso} kg — IMC {l.imc}
          </div>
        ))}
      </div>
    </div>

    {/* ================= DIETAS ================= */}
    <div>
      <strong style={{ fontSize: "14px" }}>Dietas</strong>

      {dietas.length === 0 ? (
        <p style={{ marginTop: "5px", fontSize: "13px" }}>No hay dietas</p>
      ) : (
        <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "8px" }}>
          {dietas
            .sort((a, b) => {
              const fechaA = a.fecha?.seconds
                ? new Date(a.fecha.seconds * 1000)
                : new Date(a.fecha);

              const fechaB = b.fecha?.seconds
                ? new Date(b.fecha.seconds * 1000)
                : new Date(b.fecha);

              return fechaB - fechaA;
            })
            .map(d => (
              <div key={d.id} style={{
                padding: "10px",
                borderRadius: "8px",
                background: isDark ? "#020617" : "#ffffff",
                border: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px"
              }}>
<div style={{ fontSize: "13px", minWidth: 0, flex: 1 }}>                  <div style={{ marginBottom: "2px" }}>
                    📅 {formatFecha(d.fecha)}
                  </div>



                  <a
  href={d.url}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: isDark ? "#60a5fa" : "#2563eb",
    fontWeight: "500",
    fontSize: "13px",
    textDecoration: "none",
    display: "inline-block",
    wordBreak: "break-word",      // 👈 clave
    overflowWrap: "break-word"    // 👈 clave
  }}
>
  📄 {d.nombreArchivo}
</a>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    eliminarDieta(d.id);
                  }}
                  style={{
                    background: "#ef4444",
                    color: "white",
                    borderRadius: "6px",
                    padding: "5px 10px",
                    fontSize: "11px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  X
                </button>
              </div>
            ))}
        </div>
      )}
    </div>

  



                       {/* SUBIR DIETA */}
<div style={{
  marginTop: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  
}}>

  
{/* 🔥 BOTÓN AGREGAR DIETA */}
<button
  onClick={() => setMostrarFormularioDieta(!mostrarFormularioDieta)}
  style={{
    background: "#3b82f6",
    color: "white",
    borderRadius: "8px",
    padding: "8px 12px",
    border: "none",
    cursor: "pointer",
    fontWeight: "600"
  }}
>
  ➕ Agregar dieta
</button>


{/* 🔥 FORMULARIO DESPLEGABLE */}
{mostrarFormularioDieta && (
  <div style={{
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "10px",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    background: "#f8fafc"
  }}>

    <input
      style={input}
      placeholder="Nombre PDF"
      value={nuevoNombreDieta}
      onChange={(e) => setNuevoNombreDieta(e.target.value)}
    />

    <input
      style={input}
      placeholder="Link PDF"
      value={nuevaDietaUrl}
      onChange={(e) => setNuevaDietaUrl(e.target.value)}
    />

    <div style={{ display: "flex", gap: "8px" }}>

      {/* ✔ GUARDAR */}
      <button
  onClick={async () => {

    const confirmacion = window.confirm(
      "⚠️ ¿Seguro que quieres subir la dieta?"
    );

    if (!confirmacion) return;

    await guardarDieta(id);
    setMostrarFormularioDieta(false);

  }}
  style={{
    background: "#16a34a",
    color: "white",
    borderRadius: "8px",
    padding: "8px 12px",
    border: "none",
    cursor: "pointer",
    fontWeight: "600"
  }}
>
  ✔ Guardar
</button>
      {/* ✖ CANCELAR */}
      <button
        onClick={() => {
          setMostrarFormularioDieta(false);
          setNuevoNombreDieta("");
          setNuevaDietaUrl("");
        }}
        style={{
          background: "#ef4444",
          color: "white",
          borderRadius: "8px",
          padding: "8px 12px",
          border: "none",
          cursor: "pointer",
          fontWeight: "600"
        }}
      >
        ✖ Cancelar
      </button>

    </div>

  </div>
)}

</div>
                        

                        {/* OBSERVACIONES */}
                        <div style={{ marginTop: "15px" }}>
                          <h4>📝 Observaciones</h4>
                              {/* 🔥 BOTÓN OBSERVACIONES */}
<div style={{ marginTop: "10px" }}>
  <button
    style={{
      background: "#3b82f6",
      color: "white",
      borderRadius: "8px",
      padding: "6px 12px",
      fontSize: "12px",
      border: "none",
      cursor: "pointer",
      transition: "0.2s"
    }}
    onClick={(e) => {
      e.stopPropagation();
      setPacienteSeleccionado(id);
      setObservacionEditando(null);
      setNuevaObservacion("");
      setMostrarObservaciones(true);
    }}
    onMouseEnter={e => e.currentTarget.style.background = "#2563eb"}
    onMouseLeave={e => e.currentTarget.style.background = "#3b82f6"}
  >
    Agregar Observaciones
  </button>
</div>
                          {observaciones.map(o => (
  <div key={o.id} style={{
    borderLeft: "4px solid #3b82f6",
    padding: "10px",
    marginTop: "10px",
    background: "#f8fafc",
    borderRadius: "6px",
  }}>

<p style={{
  margin: 0,
  overflowWrap: "break-word",
  wordBreak: "break-word"
}}>
  {o.texto}
</p>
    <small>📅 {formatFecha(o.fecha)}</small>
    
  </div>
))}
                          
                        </div>

                      </div>
                    )}

                  </div>
                ))}
            </div>
          )}
        </>
      )}

      {/* 🔥 MODAL OBSERVACIONES */}
{mostrarObservaciones && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  }}>

    <div 
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "500px",
        maxHeight: "80%",
        overflowY: "auto"
      }}>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>📝 Observaciones</h3>
        <button onClick={() => setMostrarObservaciones(false)}>❌</button>
      </div>

      <hr />

      {/* LISTADO DE OBSERVACIONES */}
      {observaciones.length === 0 ? (
        <p>No hay observaciones</p>
      ) : (
        observaciones.map(o => (
          <div key={o.id} style={{
            borderLeft: "4px solid #3b82f6",
            padding: "10px",
            marginTop: "10px",
            background: observacionEditando?.id === o.id ? "#e0f2fe" : "#f8fafc",
            borderRadius: "6px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <div 
              onClick={() => {
                setObservacionEditando(o);
                setNuevaObservacion(o.texto);
              }}
              style={{ cursor: "pointer", flex: 1 }}
            >
              <p style={{
  margin: 0,
  overflowWrap: "break-word",
  wordBreak: "break-word"
}}>
  {o.texto}
</p>
              <small style={{ color: "gray" }}>📅 {formatFecha(o.fecha)}</small>
            </div>

            {/* BOTÓN ELIMINAR */}
            <button
              onClick={() => eliminarObservacion(o.id)}
              style={{
                marginLeft: "10px",
                background: "#ef4444",
                color: "white",
                borderRadius: "6px",
                padding: "4px 8px",
                cursor: "pointer"
              }}
            >
              Eliminar
            </button>
          </div>
        ))
      )}

      {/* TEXTO NUEVA OBSERVACION */}
      <textarea
        placeholder="Escribir observación..."
        value={nuevaObservacion}
        onChange={(e) => setNuevaObservacion(e.target.value)}
        style={{
          width: "100%",
          minHeight: "80px",
          marginTop: "10px",
          borderRadius: "8px",
          padding: "8px",
          border: "1px solid #ccc"
        }}
      />

      {/* BOTÓN GUARDAR / ACTUALIZAR */}
      <button
  onClick={() => {
    if (observacionEditando) {
      actualizarObservacion(observacionEditando.id, nuevaObservacion);
    } else {
      guardarObservacion(pacienteSeleccionado, nuevaObservacion);
    }
  }}
  style={{
    marginTop: "10px",
    padding: "8px 12px",
    borderRadius: "6px",
    background: "#3b82f6",
    color: "white",
    cursor: "pointer"
  }}
>
  {observacionEditando ? "Actualizar observación" : "Guardar observación"}
</button>

    </div>
  </div>
)}



   
 {/* TAB CALENDARIO */}
{tab === "calendario" && (
  <div style={{ width: "100%" }}>
    <h2>Calendario</h2>
    <hr style={{ marginBottom: "20px" }} />

    {/* Componente del calendario */}
    <CalendarioNutricionista turnos={turnos} pacientes={pacientes} />
  </div>
)}

 {/* TAB NUTRITIPS */}



{tab === "nutritips" && (
  <>
    <h2>💡 Nutritips</h2>
    <hr style={{ marginBottom: "20px" }} />

    {/* BOTÓN */}
    <button
      onClick={() => setMostrarFormularioTip(!mostrarFormularioTip)}
      style={{
        background: "#3b82f6",
        color: "white",
        borderRadius: "8px",
        padding: "10px 14px",
        border: "none",
        cursor: "pointer",
        fontWeight: "600",
        marginBottom: "15px"
      }}
    >
      ➕ Agregar Nutritip
    </button>

    {/* FORMULARIO */}
    {mostrarFormularioTip && (
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "12px",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        background: "#f8fafc",
        marginBottom: "15px"
      }}>
        <input
          value={nuevoTipTitulo}
          onChange={(e) => setNuevoTipTitulo(e.target.value)}
          placeholder="Título"
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            boxSizing: "border-box"
          }}
        />

        <textarea
          value={nuevoTipTexto}
          onChange={(e) => setNuevoTipTexto(e.target.value)}
          placeholder="Contenido del tip"
          style={{
            width: "100%",
            minHeight: "80px",
            borderRadius: "8px",
            padding: "8px",
            border: "1px solid #ccc",
            boxSizing: "border-box",
            resize: "vertical"
          }}
        />

<div style={{ display: "flex", gap: "8px" }}>

<button
  onClick={async () => {

    const confirmacion = window.confirm(
      "⚠️ ¿Seguro que quieres enviar este Nutritip?"
    );

    if (!confirmacion) return;

    await guardarNutritip();

  }}
  style={{
    background: "#16a34a",
    color: "white",
    borderRadius: "8px",
    padding: "8px 12px",
    border: "none",
    cursor: "pointer"
  }}
>
  ✔
</button>

<button
  onClick={() => {
    setMostrarFormularioTip(false);
    setNuevoTipTitulo("");
    setNuevoTipTexto("");
  }}
  style={{
    background: "#ef4444",
    color: "white",
    borderRadius: "8px",
    padding: "8px 12px",
    border: "none",
    cursor: "pointer"
  }}
>
  ✖
</button>

</div>
      </div>
    )}

    {/* LISTADO */}
    {nutritips.length === 0 ? (
      <p>No hay nutritips</p>
    ) : (
      nutritips
      .sort((a, b) => {
        const fechaA = a.fecha?.seconds
          ? new Date(a.fecha.seconds * 1000)
          : new Date(a.fecha);
    
        const fechaB = b.fecha?.seconds
          ? new Date(b.fecha.seconds * 1000)
          : new Date(b.fecha);
    
        return fechaB - fechaA; // 🔥 más nuevos arriba
      })
      .map((tip) => (
        <div
          key={tip.id}
          style={{
            background: isDark ? "#0f172a" : "white",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            marginBottom: "10px"
          }}
        >
          {editandoTip === tip.id ? (
            <>
              <input
                value={nuevoTipTitulo}
                onChange={(e) => setNuevoTipTitulo(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginBottom: "8px"
                }}
              />

              <textarea
                value={nuevoTipTexto}
                onChange={(e) => setNuevoTipTexto(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "80px",
                  borderRadius: "8px",
                  padding: "8px",
                  border: "1px solid #ccc",
                  boxSizing: "border-box",
                  resize: "vertical"
                }}
              />

              <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                <button
                  onClick={() => guardarEdicionTip(tip.id)}
                  style={{
                    background: "#16a34a",
                    color: "white",
                    borderRadius: "6px",
                    padding: "6px 10px",
                    border: "none"
                  }}
                >
                  ✔
                </button>

                <button
                  onClick={() => setEditandoTip(null)}
                  style={{
                    background: "#ef4444",
                    color: "white",
                    borderRadius: "6px",
                    padding: "6px 10px",
                    border: "none"
                  }}
                >
                  ✖
                </button>
              </div>
            </>
          ) : (
            <>
              <strong>{tip.titulo}</strong>

              <p
                style={{
                  marginTop: "5px",
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap"
                }}
              >
                {tip.texto}
              </p>

              <small style={{ color: "#64748b" }}>
                📅 {formatFecha(tip.fecha)}
              </small>

              <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                <button
                  onClick={() => {
                    setEditandoTip(tip.id);
                    setNuevoTipTitulo(tip.titulo);
                    setNuevoTipTexto(tip.texto);
                  }}
                  style={{
                    background: "#3b82f6",
                    color: "white",
                    borderRadius: "6px",
                    padding: "4px 8px",
                    border: "none",
                    fontSize: "12px"
                  }}
                >
                  Editar
                </button>

                <button
                  onClick={() => eliminarNutritip(tip.id)}
                  style={{
                    background: "#ef4444",
                    color: "white",
                    borderRadius: "6px",
                    padding: "4px 8px",
                    border: "none",
                    fontSize: "12px"
                  }}
                >
                  Eliminar
                </button>
              </div>
            </>
          )}
        </div>
      ))
    )}
  </>
)}


 {/* TAB GUIAS */}

 {tab === "guia" && (
  <>
    <h2> 📚 Guías </h2>
    <hr style={{ marginBottom: "20px" }} />

    {/* FORMULARIO */}
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginBottom: "20px"
    }}>
      <input
        style={input}
        placeholder="Título"
        value={guiaTitulo}
        onChange={(e) => setGuiaTitulo(e.target.value)}
      />

      <input
        style={input}
        placeholder="Link del PDF (Google Drive)"
        value={guiaUrl}
        onChange={(e) => setGuiaUrl(e.target.value)}
      />

<button
  onClick={async () => {

    if (!guiaTitulo || !guiaUrl) {
      alert("Completa título y link");
      return;
    }

    const confirmacion = window.confirm(
      "⚠️ ¿Seguro que quieres guardar esta guía?"
    );

    if (!confirmacion) return;

    await addDoc(collection(db, "guiaMedicion"), {
      titulo: guiaTitulo,
      url: guiaUrl,
      createdAt: new Date()
    });

    alert("Guía guardada");

    setGuiaTitulo("");
    setGuiaUrl("");

  }}
  style={{
    background: "#16a34a",
    color: "white",
    padding: "10px 14px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600"
  }}
>
  ✔ Guardar guía
</button>

    </div>

    {/* LISTADO */}
    {guias.length === 0 ? (
  <p>No hay guías cargadas</p>
) : (
  [...guias]
    .sort((a, b) => {
      const fechaA = a.createdAt?.seconds
        ? new Date(a.createdAt.seconds * 1000)
        : new Date(a.createdAt);

      const fechaB = b.createdAt?.seconds
        ? new Date(b.createdAt.seconds * 1000)
        : new Date(b.createdAt);

      return fechaB - fechaA;
    })
    .map((g, index) => {

      const esNueva = index === 0;

      return (
        <div
          key={g.id}
          style={{
            background: esNueva ? "#ecfdf5" : "white",
            padding: "15px",
            borderRadius: "10px",
            border: esNueva
              ? "1px solid #22c55e"
              : "1px solid #e2e8f0",
            marginBottom: "10px",
            transition: "0.2s"
          }}
        >

          {/* TITULO */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "6px"
          }}>
            <strong style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              {g.titulo || "Guía de medición"}

              {esNueva && (
                <span style={{
                  background: "#22c55e",
                  color: "white",
                  fontSize: "10px",
                  padding: "2px 6px",
                  borderRadius: "6px",
                  fontWeight: "600"
                }}>
                  NUEVO
                </span>
              )}
            </strong>

            <small style={{ color: "#64748b" }}>
              📅 {formatFecha(g.createdAt)}
            </small>
          </div>

        

{/* BOTONES */}
<div style={{
  marginTop: "10px",
  display: "flex",
  gap: "8px"
}}>

  <a
    href={g.url}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      background: "#3b82f6",
      color: "white",
      padding: "6px 10px",
      borderRadius: "8px",
      textDecoration: "none",
      fontSize: "12px"
    }}
  >
    Ver guía
  </a>

  <button
    onClick={async () => {
      if (window.confirm("¿Eliminar esta guía?")) {
        await deleteDoc(doc(db, "guiaMedicion", g.id));
      }
    }}
    style={{
      background: "#ef4444",
      color: "white",
      padding: "6px 10px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      fontSize: "12px"
    }}
  >
    Eliminar
  </button>

</div>

        </div>
      );
    })
)}
  </>
)}


 {/* TAB MEDICION */}


 {tab === "medicion" && (
  <>
    <h2>📊 Mediciones</h2>

    <p
      style={{
        fontSize: "13px",
        color: "#64748b",
        marginBottom: "15px"
      }}
    >
      Registro antropométrico y seguimiento nutricional
    </p>

    <div
      style={{
        background: isDark ? "#0f172a" : "white",
        padding: "20px",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        display: "flex",
        flexDirection: "column",
        gap: "12px"
      }}
    >

     {/* ================= SELECT PACIENTE ================= */}

<select
  value={pacienteSeleccionado || ""}
  onChange={(e) => {

    const id = e.target.value;

    setPacienteSeleccionado(id);

    const p = pacientes[id];

    if (p) {

      setPesoMedicion(p.pesoActual || "");

      setAlturaMedicion(p.altura || "");

      setCinturaMedicion(p.cintura || "");

      setCaderaMedicion(p.cadera || "");

      setGeneroMedicion(p.genero || "");

      traerMediciones(id);
    }
  }}
  style={{
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  }}
>
  <option value="">
    Seleccionar paciente
  </option>

  {Object.entries(pacientes)

.filter(([id, p]) =>
  p.role === "paciente"
)

.sort((a, b) => {

  const nombreA =
    `${a[1].nombre || ""} ${a[1].apellido || ""}`
      .toLowerCase();

  const nombreB =
    `${b[1].nombre || ""} ${b[1].apellido || ""}`
      .toLowerCase();

  return nombreA.localeCompare(nombreB);

})

.map(([id, p]) => (

      <option key={id} value={id}>
        {p.nombre} {p.apellido}
      </option>

    ))}
</select>

{/* ================= BOTON DESPLEGAR ================= */}

<button
  onClick={() =>
    setMostrarFormularioMedicion(
      !mostrarFormularioMedicion
    )
  }
  style={{
    marginTop: "15px",
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    background: "#0f172a",
    color: "white",
    fontWeight: "600",
    cursor: "pointer"
  }}
>
  {mostrarFormularioMedicion
    ? "✖ Cancelar medición"
    : "➕ Hacer medición"}
</button>

{/* ================= FORMULARIO ================= */}

{mostrarFormularioMedicion && (

  <div style={{
    marginTop: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  }}>

  {/* ================= PESO ================= */}

<div style={inputWrapper}>
  <input
    type="number"
    placeholder="Peso"
    value={pesoMedicion}
    onChange={(e) =>
      setPesoMedicion(e.target.value)
    }
    style={inputWithUnit}
  />

  <span style={unitLabel}>
    kg
  </span>
</div>

{/* ================= ALTURA ================= */}

<div style={inputWrapper}>
  <input
    type="number"
    placeholder="Altura"
    value={alturaMedicion}
    onChange={(e) =>
      setAlturaMedicion(e.target.value)
    }
    style={inputWithUnit}
  />

  <span style={unitLabel}>
    cm
  </span>
</div>

    {/* ================= CINTURA ================= */}

    <input
      type="number"
      placeholder="Cintura (cm)"
      value={cinturaMedicion}
      onChange={(e) =>
        setCinturaMedicion(e.target.value)
      }
      style={input}
    />

    {/* ================= CADERA ================= */}

    <input
      type="number"
      placeholder="Cadera (cm)"
      value={caderaMedicion}
      onChange={(e) =>
        setCaderaMedicion(e.target.value)
      }
      style={input}
    />

    {/* ================= CUELLO ================= */}

    <input
      type="number"
      placeholder="Cuello (cm)"
      value={cuelloMedicion}
      onChange={(e) =>
        setCuelloMedicion(e.target.value)
      }
      style={input}
    />

    {/* ================= PECHO ================= */}

    <input
      type="number"
      placeholder="Pecho (cm)"
      value={pechoMedicion}
      onChange={(e) =>
        setPechoMedicion(e.target.value)
      }
      style={input}
    />

    {/* ================= BRAZO ================= */}

    <input
      type="number"
      placeholder="Brazo (cm)"
      value={brazoMedicion}
      onChange={(e) =>
        setBrazoMedicion(e.target.value)
      }
      style={input}
    />

    {/* ================= OBSERVACIONES ================= */}

    <textarea
      placeholder="Observaciones"
      value={observacionesMedicion}
      onChange={(e) =>
        setObservacionesMedicion(e.target.value)
      }
      style={{
        width: "100%",
        minHeight: "100px",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        resize: "vertical",
        boxSizing: "border-box"
      }}
    />

    {/* ================= BOTÓN ================= */}

    <button
  onClick={async () => {

    const confirmacion = window.confirm(
      "⚠️ ¿Seguro que quieres guardar esta medición?"
    );

    if (!confirmacion) return;

    await guardarMedicion();

  }}
  style={{
    background: "#22c55e",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "10px 14px",
    cursor: "pointer",
    fontWeight: "600"
  }}
>
  Guardar medición
</button>

  </div>

)}
</div>
    {/* ================= HISTORIAL ================= */}
    <div style={{ marginTop: "20px" }}>
      <h3>📚 Historial de mediciones</h3>

      {historialMediciones.length === 0 ? (
        <p>No hay mediciones</p>
      ) : (
        historialMediciones.map((m) => (

          <div
            key={m.id}
            style={{
              background: isDark ? "#020617" : "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "16px",
              marginTop: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "8px"
            }}
          >
        
            {/* HEADER */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
        
              <strong style={{ fontSize: "16px" }}>
                📊 Medición
              </strong>
        
              <span style={{
                fontSize: "12px",
                color: "#64748b"
              }}>
                {formatFecha(m.fecha)}
              </span>
        
            </div>
        
            {/* DATOS PRINCIPALES */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))",
              gap: "10px",
              fontSize: "13px"
            }}>
        
              <div>⚖️ Peso: <strong>{m.peso} kg</strong></div>
        
              <div>📏 Altura: <strong>{m.altura} cm</strong></div>
        
              <div>🧮 IMC: <strong>{m.imc}</strong></div>
        
              <div>🔥 % Grasa: <strong>{m.grasaCorporal}%</strong></div>
        
              <div>💪 Masa magra: <strong>{m.masaMagra} kg</strong></div>
        
              <div>🧈 Masa grasa: <strong>{m.masaGrasa} kg</strong></div>
        
              <div>❤️ ICA: <strong>{m.ica}</strong></div>
        
              <div>📐 ICC: <strong>{m.icc}</strong></div>
        
              <div>⚡ TMB: <strong>{m.tmb} kcal</strong></div>
        
              <div>🎂 Edad: <strong>{m.edad}</strong></div>
        
              <div>🧑 Género: <strong>{m.genero}</strong></div>
              <div>
  🫀 Grasa visceral:
  <strong> {m.grasaVisceral}</strong>
</div>
        
            </div>
        
            {/* MEDIDAS */}
            <div style={{
              marginTop: "8px",
              paddingTop: "8px",
              borderTop: "1px solid #e2e8f0",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(120px,1fr))",
              gap: "8px",
              fontSize: "13px"
            }}>
        
              <div>📏 Cintura: {m.cintura} cm</div>
        
              <div>🍑 Cadera: {m.cadera} cm</div>
        
              <div>🦒 Cuello: {m.cuello} cm</div>
        
              <div>🏋️ Pecho: {m.pecho} cm</div>
        
              <div>💪 Brazo: {m.brazo} cm</div>
        
            </div>
        
            {/* OBSERVACIONES */}
            {m.observaciones && (
              <div style={{
                marginTop: "10px",
                padding: "10px",
                borderRadius: "8px",
                background: isDark ? "#0f172a" : "#f8fafc",
                fontSize: "13px"
              }}>
                📝 {m.observaciones}
              </div>
            )}
        
          </div>
        ))
      )}
    </div>
  </>
)}


 {/* TAB NOTICIAS */}


{tab === "noticias" && (
  <div
    style={{
      maxWidth: "600px",   // 👈 límite en PC
      margin: "0 auto"     // 👈 centrado
    }}
  >
    <h2>Noticias de nutrición</h2>
    <hr style={{ marginBottom: "20px" }} />

    {noticias.length === 0 ? (
      <p>No hay noticias todavía</p>
    ) : (
      noticias.map(n => (
        <div
          key={n.id}
          style={{
            background: isDark ? "#0f172a" : "white",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            marginBottom: "10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
          }}
        >
          <img
            src={n.imagen || "https://via.placeholder.com/600x400?text=Nutricion"}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/600x400?text=Nutricion";
            }}
            style={{
              width: "100%",
              maxHeight: "180px",      // 👈 cambio clave
              aspectRatio: "16 / 9",   // 👈 evita deformación
              objectFit: "cover",
              borderRadius: "8px",
              marginBottom: "10px"
            }}
          />

          <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
            {n.titulo}
          </p>

          {n.descripcion && (
            <p style={{
              fontSize: "14px",
              marginBottom: "8px",
              color: isDark ? "#cbd5f5" : "#444"
            }}>
              {n.descripcion}
            </p>
          )}

          <p style={{ fontSize: "12px", color: "gray" }}>
            {n.fuente}
          </p>

          <a
            href={n.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              fontSize: "14px"
            }}
          >
            Leer noticia →
          </a>
        </div>
      ))
    )}
  </div>
)}

{/* FOOTER */}
<div
  style={{
    width: "100%",
    marginTop: "30px",
    padding: "18px 10px",

    textAlign: "center",

    fontSize: "12px",
    color: "#64748b",

    borderTop: "1px solid rgba(255,255,255,0.06)",

    letterSpacing: "0.3px"
  }}
>
  © {new Date().getFullYear()} RNutricion · Todos los derechos reservados
  <br />
  <span style={{ fontSize: "11px", opacity: 0.7 }}>
    Desarrollado por RNutricion
  </span>
</div>

 </div>
 
</div>


)}
          
            

        

     

      {/* PANEL PACIENTE */}
      {userData.role === "paciente" && (
  <div
    style={{
      display: "flex",
      flexDirection: "column", // 🔥 CLAVE
      width: "100%"
    }}
  >
{/* HEADER */}
<div
  style={{
    width: "95%",
    maxWidth: "1200px",
    margin: "20px auto",
    height: "60px",
    borderRadius: "16px",
    padding: "0 15px",

    background: "#0f172a",

    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",

    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    border: "1px solid rgba(255,255,255,0.15)",

    position: "sticky",
    top: 10,
    zIndex: 1000,

    boxSizing: "border-box"
  }}
>


      {/* IZQUIERDA */}
    
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
  <img
    src="logo512sinfondo.png"
    alt="logo"
    style={{
      width: "44px",
      height: "44px",
      objectFit: "cover",
      borderRadius: "8px"
    }}
  />

  <span
    style={{
      color: "white",
      fontWeight: 700,
      fontSize: "16px"
    }}
  >
    RNutricion
  </span>
</div>

  {/* CENTRO */}
  <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden"
  }}
>
  <div
    style={{
      color: "white",
      fontSize: "16px",
      padding: "5px 9px",
      borderRadius: "999px",

      display: "flex",
      alignItems: "center",
      gap: "8px",

      maxWidth: "280px", // 👈 límite real
      overflow: "hidden",
      whiteSpace: "nowrap"
    }}
  >
    <span style={{ fontSize: "18px" }}>
      |
    </span>

    <span style={{ fontSize: "15px", }}>
      Bienvenido,
    </span>

    <strong
      style={{
        fontSize: "15px",
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}
      title={userData?.nombre}
    >
      {userData?.nombre || "Paciente"}
    </strong>
  </div>
</div>
  
{/* DERECHA */}
<div
  style={{
    justifySelf: "end",
    display: "flex",
    alignItems: "center",
  }}
>
  <button
    onClick={() => {
      const confirmar = window.confirm("¿Seguro que quieres cerrar sesión?");
      if (confirmar) handleLogout();
    }}
    style={{
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.15)",
      border: "1px solid rgba(255,255,255,0.25)",
      color: "white",
      fontSize: "15px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      lineHeight: "1",
      transition: "0.2s"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.3)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.15)";
    }}
  >
    ✕
  </button>
</div>

    </div>

    {/* BODY */}
    <div style={{ padding: "20px" }}>
      
      {/* GRID */}
      <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%"
  }}
>

      
        
     

  
   

 {/* TURNOS */}
 <div style={{ background: "white", padding: "20px", borderRadius: "10px" }}>
  <h3>📅 Solicitar turno</h3>

  {/* Botón toggle con texto dinámico */}
  <button
  onClick={() => setMostrarCalendario(!mostrarCalendario)}
  style={{
    padding: "8px 16px",
    borderRadius: "8px",
    background: mostrarCalendario ? "#0f172a" : "#0f172a",
    color: "white",
    border: "none",
    cursor: "pointer",
    marginBottom: "10px",
    fontWeight: 600,
    fontSize: "13px",
    letterSpacing: "0.3px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px"
  }}
>
  {mostrarCalendario ? "CERRAR" : "ABRIR"}
</button>

  {/* Mostrar calendario y horarios solo si mostrarCalendario es true */}
  {mostrarCalendario && (
    <>
      {/* Calendario */}
      <div
  style={{
    width: "100%",
    maxWidth: "380px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "center"
  }}
>
        <DatePicker
          selected={fechaSeleccionada}
          onChange={(date) => {
            setFechaTurno(date.toISOString());
            setTurnoSeleccionado(null); // 🔥 clave
          }}
          inline
          minDate={new Date()}
          filterDate={(date) => date.getDay() !== 0}
          formatWeekDay={(day) => {

            const dias = {
        
              Sunday: "D",
        
              Monday: "L",
        
              Tuesday: "M",
        
              Wednesday: "Mi",
        
              Thursday: "J",
        
              Friday: "V",
        
              Saturday: "S",
        
            };
        
            return dias[day];
        
          }}
        
          className="custom-calendar"
          dayClassName={(date) => {
            const dateStr = date.toISOString().split("T")[0];
          
            if (diasBloqueados.includes(dateStr)) return "dia-bloqueado";
          
            return "";
          }}
        />
      </div>

      {/* Horarios disponibles */}
      <div style={{ 
        marginTop: "10px", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center"
      }}>
        <strong>Horarios disponibles:</strong>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginTop: "8px",
            justifyContent: "center",
          }}
        >
          {horariosDisponibles.length === 0 ? (
            <p>No hay horarios disponibles</p>
          ) : (
            horariosDisponibles.map(hora => {
              const esSeleccionado =
                turnoSeleccionado &&
                turnoSeleccionado.getHours() === hora &&
                turnoSeleccionado.toDateString() === fechaSeleccionada.toDateString();

              return (
                <button
                  key={hora}
                  onClick={() => {
                    const nuevaFecha = new Date(fechaSeleccionada);
                    nuevaFecha.setHours(hora, 0, 0, 0);
                    setTurnoSeleccionado(nuevaFecha);
                  }}
                  style={{
                    fontSize: "18px",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    transition: "0.2s",
                    background: esSeleccionado ? "#15803d" : "#f1f5f9",
                    color: esSeleccionado ? "white" : "#111",
                    border: esSeleccionado ? "2px solid #059669" : "1px solid #ccc",
                    transform: esSeleccionado ? "scale(1.05)" : "scale(1)",
                  }}
                >
                  {hora}:00
                </button>
              );
            })
          )}
        </div>

        {/* Turno seleccionado */}
        {turnoSeleccionado && (
  <div
    style={{
      marginTop: "25px",             // más espacio desde los horarios
      fontSize: "18px",
      padding: "14px 18px",
      background: "#ecfdf5",
      border: "2px solid #10b981",
      borderRadius: "10px",
      width: "70%",                  // un poco más ancho
      maxWidth: "400px",
      fontWeight: "bold",
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)", // sombra más marcada
    }}
  >
    <strong>Turno seleccionado:</strong>
    <p>📅 {turnoSeleccionado.toLocaleDateString()}</p>
    <p>🕐 {turnoSeleccionado.getHours()}:00</p>
  </div>
)}
      </div>

      

{/* 👇 MENSAJE CUANDO FALTA SELECCIONAR HORA */}
{fechaSeleccionada && !turnoSeleccionado && (
  <p style={{ 
    marginTop: "10px", 
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px"
  }}>
    Seleccioná un horario para continuar
  </p>
)}

      {/* Botón confirmar turno */}
      {fechaSeleccionada && turnoSeleccionado && (
  <button
  style={{
    width: "60%",
    fontSize: "15px",
    maxWidth: "400px",
    padding: "6px 12px",
    borderRadius: "8px",
    border: "none",
    background: "#15803d",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    margin: "12px auto 0 auto",
    display: "block"
  }}
  onClick={async () => {

    const confirmacion = window.confirm(
      "⚠️ ¿Seguro que deseas confirmar este turno?"
    );

    if (!confirmacion) return;

    await crearTurno();

  }}
>
  Confirmar turno
</button>
)}
    </>
  )}
</div>

    

   {/* MIS TURNOS */}
   <div style={{
  background: "white",
  padding: "20px",
  borderRadius: "10px",
  marginTop: "20px"
}}>

  <h3>📌 Mis turnos</h3>

  {/* 🔵 PRÓXIMOS TURNOS */}
  <h4 style={{ marginTop: "15px" }}>📅 Próximos turnos</h4>

{proximosTurnos.length === 0 ? (
  <p>No tenés turnos próximos</p>
) : (
  <>
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "15px"
    }}>
      
      {(verTodosTurnos ? proximosTurnos : proximosTurnos.slice(0, 4)).map((t) => (
        <div key={t.id} style={{
          background: "#f8fafc",
          padding: "15px",
          borderRadius: "10px",
          border: "1px solid #e2e8f0"
        }}>
          <p>
            <strong>Paciente:</strong>{" "}
            {pacientes[t.patientId]?.nombre}{" "}
            {pacientes[t.patientId]?.apellido}
          </p>

          <p>📅 {formatFechaHora24(t.fechaHora)}</p>

          <p>
            <strong>Estado:</strong>{" "}
            <span style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "5px 10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              background:
                t.estado === "confirmado"
                  ? "#dcfce7"
                  : "#fef3c7",
              color:
                t.estado === "confirmado"
                  ? "#166534"
                  : "#92400e"
            }}>
              {t.estado === "confirmado" && "✔"}
              {t.estado === "pendiente" && "⏳"}
              {t.estado.toUpperCase()}
            </span>
          </p>

          {t.estado !== "cancelado" && (
            <div style={{ marginTop: "10px" }}>
          <button
  onClick={() => {
    if (window.confirm("¿Seguro que deseas cancelar el turno?")) {
      actualizarEstadoTurno(
        t.id,
        "cancelado",
        t.fechaHora,
        true
      );
    }
  }}
>
  Cancelar turno
</button>
              <p style={{
                fontSize: "12px",
                color: "gray",
                marginTop: "5px"
              }}>
                Tenés hasta 24 horas antes para cancelar el turno
              </p>
            </div>
          )}
        </div>
      ))}
    </div>

    {/* BOTÓN VER MÁS */}
    {proximosTurnos.length > 4 && (
      <div style={{ textAlign: "center", marginTop: "15px" }}>
        <button onClick={() => setVerTodosTurnos(!verTodosTurnos)}>
          {verTodosTurnos ? "Ver menos" : "Ver todos"}
        </button>
      </div>
    )}
  </>
)}

  {/* ⚫ HISTORIAL */}
  <h4 
  style={{ 
    marginTop: "30px", 
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }}
  onClick={() => setMostrarHistorial(!mostrarHistorial)}
>
  🕘 Historial
  <span style={{ fontSize: "12px" }}>
    {mostrarHistorial ? "▲" : "▼"}
  </span>
</h4>

{mostrarHistorial && (
  historialTurnos.length === 0 ? (
    <p>No hay historial</p>
  ) : (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "15px"
    }}>
      {historialTurnos.map((t) => (
        <div key={t.id} style={{
          background: "#f8fafc",
          padding: "15px",
          borderRadius: "10px",
          border: "1px solid #e2e8f0",
          opacity: 0.8
        }}>
          <p>
            <strong>Paciente:</strong>{" "}
            {pacientes[t.patientId]?.nombre}{" "}
            {pacientes[t.patientId]?.apellido}
          </p>

          <p>📅 {formatFechaHora24(obtenerFecha(t.fechaHora))}</p>

          <p>
            <strong>Estado:</strong>{" "}
            <span style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "5px 10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",

              background:
                t.estado === "cancelado"
                  ? "#fee2e2"
                  : "#e5e7eb",

              color:
                t.estado === "cancelado"
                  ? "#991b1b"
                  : "#374151"
            }}>
              {t.estado === "cancelado" && "✖"}
              {t.estado}
            </span>
          </p>
        </div>
      ))}
    </div>
  )
)}

</div>



{/* ================= NUTRITIPS ================= */}
<div style={{
  background: "white",
  padding: "20px",
  borderRadius: "12px",
  marginTop: "20px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
}}>
  <h3 style={{ marginBottom: "15px" }}>💡 Nutritips</h3>

  {nutritips.length === 0 ? (
    <p style={{ color: "#64748b" }}>No hay recomendaciones</p>
  ) : (
    nutritips
      .sort((a, b) => {
        const fechaA = a.fecha?.seconds
          ? new Date(a.fecha.seconds * 1000)
          : new Date(a.fecha);

        const fechaB = b.fecha?.seconds
          ? new Date(b.fecha.seconds * 1000)
          : new Date(b.fecha);

        return fechaB - fechaA;
      })
      .map((t, index) => (
        <div
          key={t.id}
          style={{
            padding: "12px",
            marginBottom: "10px",
            borderRadius: "10px",
            background: "#ecfdf5",
            border: "1px solid #22c55e",
            color: "#0f172a"
          }}
        >
          {/* 🔹 TÍTULO + NUEVO */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "4px",
            flexWrap: "wrap"
          }}>
            <div style={{
              fontWeight: "600",
              fontSize: "14px",
              overflowWrap: "break-word",
              wordBreak: "break-word"
            }}>
              {t.titulo}
            </div>

            {index === 0 && (
              <span style={{
                background: "#22c55e",
                color: "white",
                fontSize: "10px",
                padding: "2px 6px",
                borderRadius: "6px",
                fontWeight: "600"
              }}>
                NUEVO
              </span>
            )}
          </div>

          {/* 🔹 Texto */}
          <div style={{
            fontSize: "13px",
            marginBottom: "6px",
            color: "#334155",
            overflowWrap: "break-word",
            wordBreak: "break-word"
          }}>
            {t.texto}
          </div>

          {/* 🔹 Fecha */}
          <div style={{
            fontSize: "12px",
            color: "#64748b"
          }}>
            📅 {formatFecha(t.fecha)}
          </div>
        </div>
      ))
  )}
{/* 🔥 FOOTER INSTAGRAM */}

<div style={{
  marginTop: "15px",
  paddingTop: "10px",
  borderTop: "1px solid #e2e8f0",
  textAlign: "center",
  fontSize: "13px",
  color: "#64748b"
}}>
  <a
    href="https://instagram.com/nutricionrocio_"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      color: "#e1306c", // 🔥 color Instagram
      fontWeight: "600",
      textDecoration: "none"
    }}
  >
    <FaInstagram />
    @nutricionrocio_
  </a>
</div>

</div>


    {/* DIETAS */}
   <div style={{
  background: "white",
  padding: "20px",
  borderRadius: "12px",
  marginTop: "20px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
}}>
  <h3 style={{ marginBottom: "15px" }}>🥗 Mis dietas</h3>

  {dietas.length === 0 ? (
    <p style={{ color: "#64748b" }}>No tenés dietas asignadas</p>
  ) : (
    dietas
      .sort((a, b) => {
        const fechaA = a.fecha?.seconds
          ? new Date(a.fecha.seconds * 1000)
          : new Date(a.fecha);

        const fechaB = b.fecha?.seconds
          ? new Date(b.fecha.seconds * 1000)
          : new Date(b.fecha);

        return fechaB - fechaA;
      })
      .map(d => (
        <a
          key={d.id}
          href={d.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 12px",
            marginBottom: "10px",
            borderRadius: "10px",
            textDecoration: "none",
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            color: "#0f172a",
            transition: "0.2s"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#ecfdf5";
            e.currentTarget.style.borderColor = "#22c55e";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#f8fafc";
            e.currentTarget.style.borderColor = "#e2e8f0";
          }}
        >
         <span style={{
  flex: 1,
  minWidth: 0,
  overflowWrap: "break-word",
  wordBreak: "break-word",
  marginRight: "10px"
}}>
  📄 {d.nombreArchivo}
</span>

          <span style={{ fontSize: "12px", color: "#64748b" }}>
            {formatFecha(d.fecha)}
          </span>
        </a>
      ))
  )}
</div>





{/* ================= GUÍA DE MEDICIÓN ================= */}
<div style={{
  background: "white",
  padding: "20px",
  borderRadius: "12px",
  marginTop: "20px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
}}>
  <h3 style={{ marginBottom: "15px" }}>📚 Info y Guías</h3>

  {guias.length === 0 ? (
    <p style={{ color: "#64748b" }}>No hay guías disponibles</p>
  ) : (
    [...guias]
      .sort((a, b) => {
        const fechaA = a.createdAt?.seconds
          ? new Date(a.createdAt.seconds * 1000)
          : new Date(a.createdAt);

        const fechaB = b.createdAt?.seconds
          ? new Date(b.createdAt.seconds * 1000)
          : new Date(b.createdAt);

        return fechaB - fechaA;
      })
      .map((g, index) => {
        const esNueva = index === 0; // 🔥 la más reciente

        return (
          <a
            key={g.id}
            href={g.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 12px",
              marginBottom: "10px",
              borderRadius: "10px",
              textDecoration: "none",
              background: esNueva ? "#ecfdf5" : "#f8fafc",
              border: esNueva
                ? "1px solid #22c55e"
                : "1px solid #e2e8f0",
              color: "#0f172a",
              transition: "0.2s"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#ecfdf5";
              e.currentTarget.style.borderColor = "#22c55e";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = esNueva
                ? "#ecfdf5"
                : "#f8fafc";
              e.currentTarget.style.borderColor = esNueva
                ? "#22c55e"
                : "#e2e8f0";
            }}
          >
            <span style={{
              flex: 1,
              minWidth: 0,
              overflowWrap: "break-word",
              wordBreak: "break-word",
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}>
               {g.titulo || "Guía de medición"}

              {esNueva && (
                <span style={{
                  background: "#22c55e",
                  color: "white",
                  fontSize: "10px",
                  padding: "2px 6px",
                  borderRadius: "6px",
                  fontWeight: "600"
                }}>
                  NUEVO
                </span>
              )}
            </span>

            <span style={{ fontSize: "12px", color: "#64748b" }}>
              {formatFecha(g.createdAt)}
            </span>
          </a>
        );
      })
  )}
</div>


{/* PESO */}
<div style={{ background: "white", padding: "20px", borderRadius: "10px", marginTop: "20px" }}>
<h3>⚖️ Actualizar peso</h3>

<p style={{ marginTop: "10px", fontSize: "13px", color: "#6b7280" }}>
  {diasRestantes(fechaBase) > 0 ? (
    <>⏳ Podés actualizar en {diasRestantes(fechaBase)} días</>
  ) : (
    <>🟢 Ya podés actualizar tu peso</>
  )}
</p>

    <input
     type="number"
     inputMode="numeric"
    
     placeholder="PESO EN KG"   
      value={nuevoPeso}
      onChange={(e) => setNuevoPeso(e.target.value.slice (0, 3))}
      style={{
        width: "200px",
        padding: "6px 8px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "14px",
        textAlign: "center",
        flexShrink: 0
      }}
    />
<p>
    <button
      onClick={actualizarPeso}
      style={{
        padding: "8px 12px",
        borderRadius: "8px",
        border: "none",
        background: "#0f172a",
        color: "white",
        fontWeight: "bold",
        cursor: "pointer",
        flexGrow: 1,            // 🔹 se expande para ocupar espacio disponible
        minWidth: "50px",       // opcional, para que nunca sea demasiado pequeño
        width: "150px",
        marginLeft: "40px"
        
        
      }}
    >
      Actualizar
    </button>
    </p>
</div>


    {/* HISTORIAL */}
    <div style={{ background: "white", padding: "20px", borderRadius: "10px", marginTop: "20px" }}>
  <h3>📊 Mi historial</h3>

  {/* Mostrar peso inicial primero */}
  <p style={{ fontWeight: "bold", color: "#15803d" }}>
  🟢 Peso inicial: {userData.pesoInicial} kg
  {imcInicial && ` - IMC: ${imcInicial}`}
  {userData.createdAt && (
    <> -  {formatFecha(userData.createdAt)}</>
  )}
  
</p>

{legajos.length === 0 ? (
  <p>Sin registros</p>
) : (
  legajosOrdenados.map((l, i) => (
    <div
      key={i}
      style={{
        background:
          i === legajosOrdenados.length - 1 ? "#dcfce7" : "#f8fafc",
        padding: "10px",
        borderRadius: "8px",
        marginBottom: "8px",
        border: "1px solid #e2e8f0"
      }}
    >
      <p>📅 {formatFecha(l.fecha)}</p>
      <p>⚖️ {l.peso} kg</p>
      <p>📊 IMC: {l.imc}</p>
    </div>
  ))
)}
</div>




</div> 

{/* GRID */}

{/* FOOTER */}
<div
  style={{
    width: "100%",
    marginTop: "30px",
    padding: "18px 10px",

    textAlign: "center",

    fontSize: "12px",
    color: "#64748b",

    borderTop: "1px solid rgba(255,255,255,0.06)",

    letterSpacing: "0.3px"
  }}
>
  © {new Date().getFullYear()} RNutricion · Todos los derechos reservados
  <br />

  <span style={{ fontSize: "11px", opacity: 0.7 }}>
    Desarrollado por RNutricion
  </span>

  <br />

  <a
    href="mailto:contacto@ronutricion.com"
    style={{
      fontSize: "11px",
      color: "#3b82f6",
      textDecoration: "none",
      fontWeight: "600"
    }}
  >
    contacto@ronutricion.com
  </a>
</div>

</div> {/* BODY */}

  

    </div> 

    

)}

      
</div> {/* CONTENEDOR GENERAL */}

</>
  );
}

export default Dashboard;





